import React, { useState , useEffect, useRef} from "react";
import { BsExclamationCircle } from "react-icons/bs";
import Next from '../assets/images/Caret.png';
import Downarrow from '../assets/images/white_down_arrow.png';
import UpArrow from '../assets/images/upArrow.png';
import { useTranslation } from "react-i18next";
import AddPlus from '../assets/smi-kudzu-images/Add_pluss.png'
import ListTick from '../assets/smi-kudzu-images/List_tick.png'
import { v4 as uuidv4 } from 'uuid';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import RightArrow from '../assets/images/right_dropdown_arrow.png';
import Copy_Text from '../assets/images/Copy_text.svg'
import Copy_Text_Plus from '../assets/kudzu-plus-images/mobile-copy-plus.png'
import MblCopytext from '../assets/images/mblCopytext.png'
import ModalLogo from '../assets/images/KLogoBlack.svg'
import ModalLogo_kudzplus from '../assets/kudzu-plus-images/KLogoBlack.svg'
import RadialFill from '../assets/images/Checkbox-blue.png'
import RadialNull from '../assets/images/Checkbox-light.png'
import { t } from "i18next";
import Oops from '../assets/images/Oops.png';
import Oops_kudzuplus from '../assets/kudzu-plus-images/Oops.png';
import { GetApiHeadersWithBearer, GetApiHeadersWithBearerForSupport, GetRequest, PostRequest, getRequestfreshDeskDomian } from '../network/NetworkUtils';
import { ACCEPT_E_SIGN_AGGREMENT, AGREEMENTS, COVERED_BY_KUDZU, COVERED_BY_KUDZU_PLUS, GET_ESIGN_AGREEMENT, GET_ESIGN_STATUS, GET_USER_PORFIE_INFO, NOTIF_COVERED_BY_KUDZU_OPT_IN, NOTIF_COVERED_BY_KUDZU_TERMS, NOTIF_MANAGE_DIRECT_DEPOSIT, NOTIF_MANAGE_SAVINGS_HABIT, NOTIF_PAYPERKS, NOTIF_PERSONAL_INFO, NOTIF_SPENDSENSE_ALERT, NOTIF_SPENDSENSE_ALERT2, SAVINGS_GOALS, SAVINGS_HABIT, SPENDING_ALERT, STATUS_SUCCESS_CODE, VALIDATE_AUTH_USER , Add_Money_PopOver, Kudzu_Plus_Opt_In, MOBILE_UPDATE_IDOLOGY_VERIFY} from "../network/URLConstants";
import Check from '../assets/images/Checkwhite.png';
import Addalerts from '../assets/images/add_alerts.png';
import lock from '../assets/images/lock.png';
import SavingsHabit from '../assets/images/SavingsHabit.png'
import coverdImg from '../assets/images/CoverdImg.png';
import { NOTIF_CARD_SERVICES, NOTIF_CUSTOMER_CARE, NOTIF_FEES, NOTIF_STATEMENTS, NOTIF_TRANSACTIONS, NOTIF_ACCOUNT_SERVICE } from '../network/URLConstants'
import { appTheme, CHECKING_CARD_CODE,SAVING_CARD_CODE } from "../helpers/utils/Utils";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import logFirebaseEvents from "../components/LogFirebaseEvents";
import CustomAlertModel from '../components/CustomComponents/CustomAlertModel';
import Radiantborder from '../assets/kudzu-plus-images/Radiantborder.png'
import { store } from "../Redux/store";
import OopsPlus from '../assets/kudzu-plus-images/OopsPluss.png';
import Cookies from 'js-cookie';
import { cbk_transaction } from "../network/URLConstants";
import { getUserMembership } from "../helpers/utils/Utils";

export async function getDeviceId() {
  let deviceId = uuidv4();
  return deviceId;
}
export async function uniqueNonces() {
  let nounce = uuidv4();
  return nounce;
}

export const fetchConfigarationData = async () => {
  const response = await fetch(`${process.env.PUBLIC_URL}/app-config.json`);
  const data = await response.json();
  return data;
};


export async function storeData(key, value) {
  var isStored = false;
  try {
    localStorage.setItem(key, JSON.stringify(value));
    isStored = true;
    return isStored;
  } catch (error) {
    return isStored;
  }
}
export const isEmailValid = (email) => {
  if (!email || email.trim() === '') {
    return "empty";
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return "not valid"
  }
  return "valid";
};
export const validateMobileNumber = (mobileNumber) => {
  const mobilePattern = /^[0-9]{10}$/;
  if (mobileNumber.trim() === '') {
    return ('Mobile number field is empty');
  } else if (mobilePattern.test(mobileNumber)) {
    return ('Valid mobile number');
  } else {
    return ('Invalid mobile number');
  }
};

export const validateMobileNumberForSCH = (mobileNumber) => {
  const value = typeof mobileNumber === 'string' ? mobileNumber : (mobileNumber == null ? '' : String(mobileNumber));
  const trimmed = value.trim();
  const mobilePattern = /^[0-9]{10}$/;
  if (trimmed === '') {
    return ('Mobile number field is empty');
  } else if (mobilePattern.test(trimmed)) {
    return ('Valid mobile number');
  } else {
    return ('Invalid mobile number');
  }
};

export async function validateAuthorizedUser(firstName, lastName, ssn, dateOfBirth, line1, line2, city, state, zipCode, countryCode, mobile, email, cardKey, accessToken) {

  const deviceId = await retrieveData('updatedDeviceId')
  const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
  const url = VALIDATE_AUTH_USER.replace('{CARD_KEY}', cardKey)
  var object = {
    "firstName": firstName,
    "lastName": lastName,
    "dateOfBirth": dateOfBirth
  }

  if (ssn)
    object.ssn = ssn.replace("-", "").replace("-", "")
  if (line1)
    object.line1 = line1
  if (line2)
    object.line2 = line2
  if (city)
    object.city = city
  if (state)
    object.state = state
  if (zipCode)
    object.zipCode = zipCode
  if (countryCode)
    object.countryCode = countryCode
  if (mobile)
    object.mobile = mobile.replace("-", "").replace("-", "")
  if (email)
    object.email = email

  const response = await PostRequest(url, object, headers)

  return response
}


export async function storeDataInRedux(key, value) {
  this.props.dispatch({ type: key, payload: value });
}


export async function retrieveData(key) {
  const value = await localStorage.getItem(key);
  if (value !== null) {
    return JSON.parse(value);
  }
  else
    return null;
}


export const autoFocusFunction = (fieldArray, getValues, setFocus) => {
  const emptyField = fieldArray.find((item) => !getValues(item))
  setFocus(emptyField);

}



export const generateRegexExpression = (policy) => {
  let pattern = "";
  if (policy?.UppercaseLength > 0) pattern += `(?=(?:.*?[A-Z]){${policy.UppercaseLength},})`;
  if (policy?.LowercaseLength > 0) pattern += `(?=(?:.*?[a-z]){${policy.LowercaseLength},})`;
  if (policy?.NonAlphaLength > 0) pattern += `(?=(?:.*?[!@#$%^&*()_+-={}\\[\\]\\|;:'",.<>/?\`~]){${policy.NonAlphaLength},})`;
  if (policy?.NumericLength > 0) pattern += `(?=(?:.*?\\d){${policy.NumericLength},})`;
  if (policy?.AlphaLength > 0) pattern += `(?=(?:.*?[A-Za-z]){${policy.AlphaLength},})`;
  pattern = `^${pattern}.{${policy?.MinimumLength},${policy?.MaximumLength}}$`;
  return new RegExp(pattern);
}


export const generateRegexExpression1 = (criteria, policy) => {
  let pattern = "";
  switch (criteria) {
    case "Uppercase":
      pattern += `(?=(?:.*?[A-Z]){${policy.UppercaseLength},})`;
      break;
    case "Lowercase":
      pattern += `(?=(?:.*?[a-z]){${policy.LowercaseLength},})`;
      break;
    case "NonAlpha":
      pattern += `(?=(?:.*?[!@#$%^&*()_+-={}\\[\\]\\|;:'",.<>/?\`~]){${policy.NonAlphaLength},})`;
      break;
    case "Numeric":
      pattern += `(?=(?:.*?\\d){${policy.NumericLength},})`;
      break;
    case "Alpha":
      pattern += `(?=(?:.*?[A-Za-z]){${policy.AlphaLength},})`;
      break;
    case "MinMax":
      pattern += `.{${policy?.MinimumLength - 1},${policy?.MaximumLength}}`
      break;

    default:
      break;
  }

  pattern = `^${pattern}.+$`;
  return new RegExp(pattern);
}


export default function LineBreaks(element, classDefined) {
  const lines = element.split("\n");
  return lines.map((line, index) => <p className={classDefined} key={index} >{line}</p>);
}

export function LineBreaksSpan(element, classDefined) {
  const lines = element.split("\n");
  return lines.map((line, index) => {
    if (index == 0) {
      return <span className={classDefined} key={index}>{line}</span>;
    } else {
      return <p className={classDefined} key={index}>{line}</p>;
    }
  });
}

export function addLineBreaks(element) {
  const lines = element.split("\n");
  return lines.map((line, index) => (
    <span key={index}>
      {line}
      <br />
    </span>
  ));
}

export function addLineBreaksNew(element) {
  const lines = element.split("\n");
  return lines.map((line, index) => (
    <span key={index} className={index === 1 ? 'custom-indent' : ''}>
      {line}
      {index < lines.length - 1 && <br />}
    </span>
  ));
}

export function removeLineBreaks(element) {
  return element.replace(/\n/g, "");
}

export function createSuperscript(text, superscriptArr) {
  if (superscriptArr.length === 1) return;

  createSuperscript(superscriptArr[0], superscriptArr.slice(1, superscriptArr.length))

  return <span>{text}<sup>{superscriptArr[0]}</sup></span>;
}


export function isBase64(str) {
  // Remove any white spaces, which might be present in some Base64 encodings
  str = str.replace(/\s/g, '');

  // Check if the string consists of valid Base64 characters
  return /^[A-Za-z0-9+/=]+$/.test(str);
}

export const ValidationIcon = ({ isFocused, isValid, isErrorShow = true, inputValueLen, appThemeData, message  }) => {

  if (isFocused) {
    return <img src={appThemeData.Pending} className="w-4 h-4" alt="Pending" />;
  }

  if (isValid && inputValueLen > 0) {
    return <img src={appThemeData.Check} className="w-4 h-4" alt="Valid" />;
  }

  if (!isValid && isErrorShow && (message || inputValueLen > 0)) {
    return <img src={appThemeData.ExclamationError} className="w-4 h-4" alt="Error" />;
  }

  return null;
};

export const displayErrorMessage = (errorMessage) => {
  const kudzuPlusTrue = store.getState().kudzuPlusTrue;
  const signUpkudzuPlusTrue = store.getState().isSignUpKudzuplusTrue;
  const appThemeData = appTheme(kudzuPlusTrue ? kudzuPlusTrue : signUpkudzuPlusTrue ? signUpkudzuPlusTrue : false );
  return (
    <div className="flex sm:mx-0 flex-row gap-4 justify-start">
      <p className={`font-hanken-grotesk font-[500] text-[16px]  
       leading-[24px] md:text-[18px] md:leading-[28px] sm:text-[12px] 
       sm:leading-[18px] text-secondary-3`}>
        <span id="custom-text-input-error" className="text-[var(--errormessage-text-color)]"> Oops! {errorMessage}</span></p>
    </div>
  )
}

export const displayErrorMessageSCHSSN = (errorMessage) => {
  const kudzuPlusTrue = store.getState().kudzuPlusTrue;
  const signUpkudzuPlusTrue = store.getState().isSignUpKudzuplusTrue;
  const appThemeData = appTheme(kudzuPlusTrue ? kudzuPlusTrue : signUpkudzuPlusTrue ? signUpkudzuPlusTrue : false );
  return (
    <div className="flex sm:mx-0 flex-row gap-4 justify-start">
      <img src={appThemeData.OopsIcon} alt="oops" className="md:w-[20px] md:h-[20px] sm:w-[14px]
        sm:h-[14px] w-[15px] h-[15px] mt-1 sm:mt-0 md:mt-1  self-start" />
      <p id="custom-text-input-error"className={`font-hanken-grotesk font-[500] text-[16px]  
       leading-[24px] md:text-[18px] md:leading-[28px] sm:text-[12px] 
       sm:leading-[18px] text-secondary-3`}>
        <span className="text-[var(--opps-text-color)] font-[600]
        lg:font-[600]"> Please check! </span><span className="text-[var(--errormessage-text-color)]">{errorMessage}</span></p>
    </div>
  )
}

export const displayKudzuplusErrorMessage = (errorMessage) => {
 
  return (
    <div className="flex sm:mx-0 flex-row gap-4 justify-start mt-8">
         <p className={`font-hanken-grotesk font-[500] text-[16px]  
       leading-[24px] md:text-[18px] md:leading-[28px] sm:text-[12px] 
       sm:leading-[18px] text-secondary-3`}>
        <span className="text-[var(--errormessage-text-color)] font-[600]
        lg:font-[600]" id="custom-text-input-error"> Oops! {errorMessage}</span></p>
    </div>
  )
}

export const displaySignupErrorMessage = (errorMessage, holdOn) => { 
  const kudzuPlusTrue = store.getState().kudzuPlusTrue;
  const signUpkudzuPlusTrue = store.getState().isSignUpKudzuplusTrue;
  const appThemeData = appTheme(kudzuPlusTrue ? kudzuPlusTrue : signUpkudzuPlusTrue ? signUpkudzuPlusTrue : false );

  return (
    <div className="flex sm:mx-0 flex-row gap-4 justify-start">
      <img src={appThemeData.OopsIcon} alt="oops" className="md:w-[20px] md:h-[20px] sm:w-[14px]
        sm:h-[14px] w-[15px] h-[15px] mt-1 sm:mt-0 md:mt-1 self-start" />
      <p id="custom-text-input-error" className="font-hanken-grotesk font-[500] text-[16px]
       leading-[24px] md:text-[18px] md:leading-[28px] sm:text-[12px] 
       sm:leading-[18px] text-secondary-3 ">
        <span className="text-[var(--opps-text-color)] font-[600]
        lg:font-[600]"> {holdOn ? 'Hold on!' : 'Oops!'}  </span><span className="text-[var(--errormessage-text-color)]">{errorMessage}</span></p>
    </div>
  )
}


// export const displaySignupErrorMessage = (errorMessage, holdOn) => {
//   return (
//     <div className="flex sm:mx-0 mx-4">
//       <img src={Oops} alt="oops" className="md:w-[20px] md:h-[20px] sm:w-[14px]
//         sm:h-[14px] w-[13px] h-[13px] mt-1" />
//       <p className="font-hanken-grotesk font-[500] text-[16px]
//        leading-[20px] sm:text-[12px] md:text-[14px] md:leading-[18px] lg:text-[14px] 
//        lg:leading-[22px] text-secondary-3 ">
//         <span className="text-[#30BC89] font-[600] ml-2 
//         lg:font-[600]"> {holdOn ? 'Hold on!' : 'Oops!'} </span>{errorMessage}</p>
//     </div>
//   )
// }
export const personalFormatPhoneNumber = (phoneNumber) => {
  if (phoneNumber === '') {
    return '';
  }
  // Use regular expressions to format the phone number
  // const formattedNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  const formattedNumber = `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6)}`;

  return formattedNumber;
}

export const DisplaySSNMessage = () => { // Rename the function to start with an uppercase letter
  // const { t } = useTranslation();

  return (
    <div className="flex sm:mx-0 mx-4">
      <img src={Oops} alt="oops" className="lg:w-[14px] lg:h-[14px] sm:w-[14px]
        sm:h-[14px] w-[13px] h-[13px] mt-1" />
      <p className="font-hanken-grotesk font-[500] md:w-[432px] text-[14px] leading-[20px] md:text-[14px] md:leading-[18px] lg:text-[14px] lg:leading-[22px] text-secondary-3 ">
        <span className="text-[var(--opps-text-color)] font-[600] ml-2 
        lg:font-[600] ">{t('please_check')} </span>
        <span className="text-[var(--errormessage-text-color)]">11{t('ssn_note')}</span>
      </p>
    </div>
  );
}
export const ssnMessageNote = (text) => { // Rename the function to start with an uppercase letter


  return (
    <div className="flex sm:mx-0 mx-4">
      <img src={Oops} alt="oops" className="lg:w-[14px] lg:h-[14px] sm:w-[14px]
        sm:h-[14px] w-[13px] h-[13px] mt-1" />
      <p className="font-hanken-grotesk font-[500] md:w-[432px] text-[14px] leading-[20px] md:text-[14px] md:leading-[18px] lg:text-[14px] lg:leading-[22px] text-secondary-3 ">
        <span className="text-[var(--opps-text-color)] font-[600] ml-2 
        lg:font-[600] ">{t('please_check')} </span>
        <span className="text-[var(--errormessage-text-color)]">12{text}</span>
      </p>
    </div>
  );
}
export const displaySuccessMessage = (errorMessage) => {
  return (
    <div className="flex flex-row gap-3 md:w-[314px] sm:w-[213px]">
      <span className="text-[var(--opps-text-color)] py-1">
        <BsExclamationCircle className="md:w-[20px] w-[14px] md:h-[18px] h-[20px]" /></span>
      <p className="font-hanken-grotesk sm:text-[12px] md:text-[18px] text-[15px] 
      leading-[28px] text-secondary-3 font-[500]">
        <span className="text-[var(--opps-text-color)]">Success! </span> <span className="text-[var(--successmessage-text-color)]">{errorMessage}</span></p>
    </div>
  )
}

export const CheckingAndSavingsHeader = ({ cardText, amount, cardNum, handleRedirect, cardDetails, accountNumber, routingNumber, handleCopyClick, handleCopyRoutingNumberClick, cardOptionsList, ImageIcon, handleCardAction, smiONECards, selectedCard, onCardSelect, isTransactionsPage, onAccountSwitch, hasSpendingAccount, hasSavingsAccount }) => {
  const isMobile = window.innerWidth < 768

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // const showAccountDetails = false;
  const [showAccountDetails, setShowAccountDetails] = useState(false);
  const [showAccountDropdown, setShowAccountDropdown] = useState(false);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const climbFeatures = useSelector(state => state.climbFeatures);
  const enabledClimbings = climbFeatures?.filter((response) => response?.enabled === true);
  const issavingsGoalEligible = enabledClimbings?.find(item => item?.code === SAVINGS_GOALS);
  const checkAccountType = cardDetails.AccountTypeBit63 === CHECKING_CARD_CODE
  const displayManageText = kudzuPlusTrue && issavingsGoalEligible && !checkAccountType && location.pathname !== '/home'
  const cards = useSelector(state => JSON.parse(state.userCards));
  const findSmiOneCard = Array.isArray(cards) && cards.some(card => card.ProgramKey === 112);
  const appThemeData = appTheme(kudzuPlusTrue)
  const accountDropdownRef = useRef(null);
    const [showCardDropdown, setShowCardDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const handleshowAccountDetails = () => {
    //  showAccountDetails = !showAccountDetails // Call the handleTryAgain function passed as a prop
    setShowAccountDetails(!showAccountDetails)
  };

  const smiONECardPath = location.pathname === '/SmioneCard';

  const handleCardDropdownToggle = () => {
    setShowCardDropdown(!showCardDropdown);
  };


  const handleCardClick = (card) => {
    if (onCardSelect) {
      onCardSelect(card);
    }
    setShowCardDropdown(false);
  };


  const handleAddSecondaryCardholder = () => {
    navigate('/AccountServices/smiONECard/AddSecondaryCardHolder');
    setShowCardDropdown(false);
  };


  // Format card display name with last 4 digits
const getCardDisplayName = (card) => {
  const name = card.NickName ? card.NickName : card.AccountTypeName;
 
  const endsWithDashDigits = /-\s*\d+$/.test(card.NickName || '');
 
  const displayNum = card.CardDisplayNumber || "";
  const hasRealDigits = /\d/.test(displayNum); // check at least one digit present
 
  const lastFour = (!endsWithDashDigits && hasRealDigits)
    ? displayNum.replace(/\D/g, '').slice(-4) // keep only digits
    : '';
 
  return lastFour ? `${name} ..${lastFour}` : name;
};



  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCardDropdown(false);
      }
      if (accountDropdownRef.current && !accountDropdownRef.current.contains(event.target)) {
        setShowAccountDropdown(false);
      }
    };


    if (showCardDropdown || showAccountDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }


    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCardDropdown, showAccountDropdown]);

  const handleAccountDropdownToggle = () => {
    setShowAccountModal(true);
  };

  const handleAccountSelect = (accountType) => {
    if (onAccountSwitch) {
      onAccountSwitch(accountType);
    }
    setShowAccountModal(false);
  };

  const closeAccountModal = () => {
    setShowAccountModal(false);
  };

  // Get spending and savings card details
  const getSpendingCard = () => cards?.find(card => card.AccountTypeBit63 === CHECKING_CARD_CODE);
  const getSavingsCard = () => cards?.find(card => card.AccountTypeBit63 === SAVING_CARD_CODE);

  const formatAmount = (amount) => {
    if (!amount && amount !== 0) return '$0.00';
    const stringValue = amount.toString();
    const parts = stringValue.split('.');
    const beforeDecimal = parts[0];
    const afterDecimal = parts[1] || '00';
    return `$${beforeDecimal}.${afterDecimal.padEnd(2, '0')}`;
  };

  const getMaskedCardNumber = (cardNum) => {
    if (!cardNum) return '';
    return (
      <span className="inline-flex items-center">
        <span className="w-5 rounded-full flex gap-1 items-center justify-center relative top-[4px]">
          <span className="text-gray-800 w-[4px] h-[4px] rounded-full bg-gray-800"></span>
          <span className="text-gray-800 w-[4px] h-[4px] rounded-full bg-gray-800"></span>
        </span>
        <span className="font-space-mono">{cardNum.slice(4)}</span>
      </span>
    );
  };


  const handleClick = () => {
    if (location.pathname === '/home') {
      // if (cardText === CHECKING || cardText === SPENDING) {
      if (cardDetails.AccountTypeBit63 === CHECKING_CARD_CODE) {
        navigate('/' + SPENDING + '');
      }else if(cardDetails?.ProgramKey !== 200){
         navigate('/SmioneCard');
      } else {
        navigate('/' + SAVINGS + '');
      }
    }
  };
  

  const maskedCardNumber = (
    <span className="inline-flex items-center">
      <span className="w-5 rounded-full flex gap-1 items-center justify-center relative top-[2px]">
        <span className="text-white font-bold w-[4px] h-[4px] rounded-full bg-white "></span>
        <span className="text-white font-bold w-[4px] h-[4px] rounded-full bg-white "></span>
      </span>
      <span style={{ fontFamily: 'Space Mono' }}>{cardNum.slice(4)}</span>
    </span>
  );
  //split the string
 
  const stringValue = amount.toString();
  const parts = stringValue.split('.');

  const beforeDecimal = parts[0]; // "100"
  const afterDecimal = parts[1] || '0'; // "5"

  let formattedValue = `${beforeDecimal}.`;

  // Add zeros based on the decimal part count
  if (afterDecimal.length === 1) {
    formattedValue += `${afterDecimal}0`; // "100.50"
  } else if (afterDecimal.length === 0) {
    formattedValue += '00'; // "100.00"
  } else {
    formattedValue += afterDecimal; // "100.5" (if there are more than one decimal places)
  }


  const balnceSplit = formattedValue.toString().split('.');
  const { t } = useTranslation();

  const handleNextIconClick = () => {
    // debugger;
    handleClick();
  };
  ///MBL Quick Action Styles
  const CardButton = 'w-[48%] h-[40px] text-[var(--btn-text-mobile)] bg-[var(--btn-bg-mobile)] font-hanken-grotesk lg:text-[16px] md:text-[14px] sm:text-[11px] md:leading-[39.71px] sm:leading-[25.8px] md:h-[50px] sm:h-[35px] inline-block rounded-full border-[3px] border-[var(--btn-bg-mobile)] text-xs font-semibold leading-normal transition duration-150 ease-in-out';
  const currentPath = window.location.pathname;
  // Use prop if passed, otherwise determine from path
  const isOnTransactionsPage = isTransactionsPage !== undefined ? isTransactionsPage : currentPath === '/Transactions';

  const handleManageSavings = () =>{
    navigate('/Toolkit/SavingGoals/ManageSavingGoal')
  }

  return (
    <div className={`smione-card-tooltip sm:flex block justify-between flex-nowrap  
     sm:my-[20px] my-[20px] md:mx-[4%] sm:ml-[6%] sm:mr-[8%] mr-[2.5rem] ml-[2.5rem] ${displayManageText ? 'md:my-[20px]' : 'items-center md:my-[20px]'}`}>

      <div className='lg:text-[26px] justify-between md:text-[26px] sm:text-[15px] text-[16px] md:leading-[36px]
      sm:leading-[23px] leading-[24px] text-[#FFFFFF] font-[500] md:font-[500] sm:font-[600] font-hanken-grotesk capitalize flex items-center gap-3 w-full'>
        <div className={`flex gap-2 w-full ${displayManageText ? '' : ''} `}>
        {ImageIcon && (<img src={ImageIcon} alt="Icon" className={`w-[20px] h-[20px]  ${displayManageText ? 'mt-[0.5rem]' : 'mt-[0.5rem]'} `} />)} 
      
        {/* <span className={`${displayManageText ? 'mb-[2.5rem]' : ''}`}>
          {isMobile ? cardText.slice(0, 13) : cardText.slice(0, 23)}
          <span className='md:text-[14px] sm:text-[9px] text-[10px] ml-2 md:leading-[14px] 
        sm:leading[6.93px] leading-[24px] tracking-[2px] font-[700]'>{maskedCardNumber}</span>
        </span> */}

         {smiONECards && smiONECards.length > 0 && cardDetails?.ProgramKey !== 200 && smiONECardPath ? (
          <div className="relative bg-[#262B3A]/[0.48] rounded px-2 py-1" ref={dropdownRef}>
            <button
              type="button"
              onClick={handleCardDropdownToggle}
                className={`${displayManageText ? '' : ''} flex items-center gap-2 cursor-pointer hover:opacity-80`}
            >
              <span className="text-white font-medium ">
                {selectedCard ? getCardDisplayName(selectedCard) : (isMobile ? cardText.slice(0, 13) : cardText.slice(0, 23))}
              </span>
              <img
                src={showCardDropdown ? UpArrow : Downarrow}
                alt="dropdown"
                className="w-3 h-3 transition-transform"
              />
            </button>
            {showCardDropdown && (
              <div className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-lg z-50 min-w-[280px] max-h-[400px] overflow-hidden border border-gray-200">
              <div className="overflow-y-auto max-h-[400px] hide-scrollbar">
                    {smiONECards.map((card, index) => (
                      <>
                      <button
                        type="button"
                        key={card.CardKey || index}
                        onClick={() => handleCardClick(card)}
                        className={`w-full px-4 py-3 cursor-pointer hover:bg-gray-50 flex items-center justify-between transition-colors bg-transparent border-0 text-left ${selectedCard?.CardKey === card.CardKey ? 'bg-[#EBF1F3]/[0.48]' : ''
                          }`}
                      >
                        <span className="text-gray-800 font-hanken-grotesk text-[14px] font-medium">
                          {getCardDisplayName(card)}
                        </span>
                        {selectedCard?.CardKey === card.CardKey && (
                          <img src={ListTick} alt="check" className="w-4 h-4" />
                        )}
                      </button>
                        {/* <div className={`bg-[var(--personal-info-border)] opacity-50  w-full ${selectedCard?.CardKey === card.CardKey ? "h-0.2 min-h-0.5" :""}`}></div> */}
                        <div class="w-full h-px bg-[#2E70FD]/[0.08]"></div>
 </>
                    ))}
                    <div className="border-t border-gray-200">
                      <button type="button"
                        onClick={handleAddSecondaryCardholder}
                        className="w-full px-4 py-3 text-left text-[#222323] font-hanken-grotesk text-[14px] font-semibold bg-[#2E70FD]/[0.08] flex items-center gap-2 transition-colors"
                      >
                        <img
                          src={AddPlus}
                          alt="Add"
                          className="w-3 h-3 transition-transform"
                        />
                        <span>{t('Add_secondary_card') || 'Add a secondary cardholder'}</span>
                      </button>
                    </div>
                  </div>
                </div>
            )}
          </div>
        ) : (
          <div className={isOnTransactionsPage ? 'flex justify-between items-center w-full' : ''}>
          {/* Card Text Section */}
          <div className={isOnTransactionsPage ? '' : ''}>
            {isOnTransactionsPage && (hasSpendingAccount || hasSavingsAccount) ? (
                <div>
                  <button type="button"
                    onClick={handleAccountDropdownToggle}
                    className="flex items-center gap-2 cursor-pointer hover:opacity-80"
                  >
                    <span className={`${displayManageText ? 'mb-[1rem]' : 'mb-[1rem]'}`}>
                      {isMobile ? cardText.slice(0, 13) : cardText.slice(0, 23)}
                      <span className='md:text-[20px] sm:text-[9px] text-[10px] ml-2 md:leading-[18px]
                        sm:leading[6.93px] leading-[24px] tracking-[2px] font-[700]'>{maskedCardNumber}</span>
                    </span>
                    <img
                      src={Downarrow}
                      alt="dropdown"
                      className="w-3 h-3 ml-2"
                    />
                  </button>
                </div>
              ) : (
              <span className={`${displayManageText ? 'mb-[1rem]' : 'mb-[1rem]'}`}>
                {isMobile ? cardText.slice(0, 13) : cardText.slice(0, 23)}
                <span className='md:text-[20px] sm:text-[9px] text-[10px] ml-2 md:leading-[18px]
                  sm:leading[6.93px] leading-[24px] tracking-[2px] font-[700]'>{maskedCardNumber}</span>
              </span>
            )}
          </div>

          {/* Amount Section */}
          <div className={`flex md:font-[500] sm:font-[400] font-[500] md:leading-[56px] sm:leading-[28.38px] leading-[37.49px] text-[#FFFFFF] ${isOnTransactionsPage ? 'ml-auto' : 'mt-2 ml-0'} font-hanken-grotesk`}>
            <div className="flex align-center">
              <div className="lg:text-[48px] md:text-[40px] sm:text-[23px] text-[44px]">${balnceSplit[0]}</div>
              <div className="lg:text-[43px] md:text-[30px] sm:text-[20px] text-[35px] lg:mt-[-12px] md:mt-[-7px] sm:mt-[-5px] mt-[-11px] md:font-[500] font-[300]">.</div>
              <div className='lg:text-[32px] md:text-[23px] sm:text-[15px] text-[22px] lg:mt-[-6px] md:mt-[-4px] sm:mt-[-3px] mt-[-5px] md:font-[400] font-[300]
               font-hanken-grotesk'>{balnceSplit[1]}</div>
              {!isOnTransactionsPage && (
                <div className='ml-6 flex items-center'>
                  {location.pathname === '/home' ? (
                    <button
                      type="button"
                      onClick={handleNextIconClick}
                      className="bg-transparent border-0 p-0 cursor-pointer"
                      aria-label={t('next')}
                    >
                      <img
                        src={Next}
                        alt=""
                        className="md:w-[auto] sm:w-[12px]"
                      />
                    </button>
                  ) : (
                    <>
                      <button
                        type="button"
                        onClick={handleshowAccountDetails}
                        className="flex items-center gap-[7px] bg-transparent border-0 p-0 cursor-pointer"
                        aria-label={showAccountDetails ? t('hide_actions') : t('show_more_actions')}
                      >
                        <span className="sm:hidden block text-[12px] text-white
                          font-hanken-grotesk">{t('more_actions')}</span>
                        <span className="sm:hidden block">
                          {showAccountDetails ? <img src={UpArrow} alt="" className="w-[auto]" /> :
                            <img src={Downarrow} alt="" className="w-[auto]" />}
                        </span>
                      </button>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
          </div>
        )}

        </div>

        {!isOnTransactionsPage && (
          <div className="sm:hidden block">
          {
            kudzuPlusTrue ? (
              <button type="button" className="flex  items-center justify-center rounded-full lg:w-[165px] md:w-[150px] sm:w-[100px] w-[96px] lg:h-[55px] md:h-[50px] sm:h-[34px] h-[34px] bg-gradient-to-r from-[#2965FB] via-[#4B70B9] to-[#30BC89] p-[2px] text-white  lg:text-[16px] md:text-[18px] sm:text-[11px] text-[14px] md:leading-[46.09px] sm:leading-[22.8px] leading-[26px]  text-[#ffff] font-[700] font-hanken-grotesk"
                data-te-ripple-init
                onClick={() => {
                  if (currentPath === "/Savings") {
                  }
                  else if (currentPath === "/home") {
                    logFirebaseEvents("Home", "Add_Money_Clicked", "Add_Money_Clicked", "");
                  }
                  else {
                    logFirebaseEvents("Spendings", "Add_Money_Clicked", "Add_Money_Clicked", "");
                  }
                  global.selectedAccountServiceCardKey = cardDetails.CardKey
                  navigate('/AccountServices/Spending/TransferMoney');
                }} style={{
                  background: "linear-gradient(141deg, #2965FB, #4B70B9, #30BC89)",
                  border: "2px solid transparent",
                  borderRadius: "9999px",
                  backgroundClip: "padding-box",
                  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.15)"
                }}>
                <div className="flex h-full items-center justify-center rounded-full w-full bg-[#324261]">
                  {t('addMoneyTittle')}
                </div>
              </button>
            ) : (
              <button type="button" className={`${isMobile ? 'add-money-tooltip' : '' } lg:w-[165px] md:w-[150px] sm:w-[100px] w-[96px] 
                        lg:h-[55px] md:h-[50px] sm:h-[34px] h-[34px] 
                        rounded-full sm:border-[1.5px] md:border-[2.5px] border-[2.5px] border-[#fff] 
                          lg:text-[16px] md:text-[18px] sm:text-[11px] text-[14px]
                         md:leading-[46.09px] sm:leading-[22.8px] 
                          leading-[26px]  text-[#ffff] font-[700] 
                          font-hanken-grotesk sm:static absolute right-[35px] top-[22px]`}
                data-te-ripple-init
                onClick={() => {
                  if (currentPath === "/Savings") {
                  }
                  else if (currentPath === "/home") {
                    logFirebaseEvents("Home", "Add_Money_Clicked", "Add_Money_Clicked", "");
                  }
                  else {
                    logFirebaseEvents("Spendings", "Add_Money_Clicked", "Add_Money_Clicked", "");
                  }
                  global.selectedAccountServiceCardKey = cardDetails.CardKey
                  const transferPath = cardDetails.AccountTypeBit63 === 1 ? '/AccountServices/smiONECard/TransferMoney' : cardDetails.AccountTypeBit63 === SAVING_CARD_CODE ? '/AccountServices/Savings/TransferMoney' : '/AccountServices/Spending/TransferMoney';
                  const transferSubIndex = cardDetails.AccountTypeBit63 === SAVING_CARD_CODE ? 0 : 1;
                  dispatch({ type: 'SELECTED_SUB_INDEX', payload: { selectedSubIndex: transferSubIndex } });
                  navigate(transferPath);
                }}> {t('addMoneyTittle')} </button>
            )
          }
          </div>
        )}
        
        </div>
        <div>
      <div className='flex items-center justify-end sm:my-[0px] mt-[30px] '>
       {!isOnTransactionsPage && (
         <div className="sm:block hidden">
          {
            kudzuPlusTrue && cardDetails?.ProgramKey === 200 ? (
              <button type="button" className="flex  items-center justify-center rounded-full lg:w-[165px] md:w-[150px] sm:w-[100px] w-[96px] lg:h-[55px] md:h-[50px] sm:h-[34px] h-[34px] bg-gradient-to-r from-[#2965FB] via-[#4B70B9] to-[#30BC89] p-[2px] text-white  lg:text-[16px] md:text-[18px] sm:text-[11px] text-[14px] md:leading-[46.09px] sm:leading-[22.8px] leading-[26px]  text-[#ffff] font-[700] font-hanken-grotesk"
                data-te-ripple-init
                onClick={() => {
                  if (currentPath === "/Savings") {
                  }
                  else if (currentPath === "/home") {
                    logFirebaseEvents("Home", "Add_Money_Clicked", "Add_Money_Clicked", "");
                  }
                  else {
                    logFirebaseEvents("Spendings", "Add_Money_Clicked", "Add_Money_Clicked", "");
                  }
                  global.selectedAccountServiceCardKey = cardDetails.CardKey
                  const transferPath = cardDetails.AccountTypeBit63 === 1 ? '/AccountServices/smiONECard/TransferMoney' : cardDetails.AccountTypeBit63 === SAVING_CARD_CODE ? '/AccountServices/Savings/TransferMoney' : '/AccountServices/Spending/TransferMoney';
                  const transferSubIndex = cardDetails.AccountTypeBit63 === SAVING_CARD_CODE ? 0 : 1;
                  dispatch({ type: 'SELECTED_SUB_INDEX', payload: { selectedSubIndex: transferSubIndex } });
                  navigate(transferPath);
                }} style={{
                  background: "linear-gradient(141deg, #2965FB, #4B70B9, #30BC89)",
                  border: "2px solid transparent",
                  borderRadius: "9999px",
                  backgroundClip: "padding-box",
                  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.15)"
                }}>
                <div className="flex h-full items-center justify-center rounded-full w-full bg-[#324261]">
                  {t('addMoneyTittle')}
                </div>
              </button>
            ) : (
              <button type="button" className="add-money-tooltip lg:w-[165px] md:w-[150px] sm:w-[100px] w-[96px] 
                        lg:h-[55px] md:h-[50px] sm:h-[34px] h-[34px] 
                        rounded-full sm:border-[1.5px] md:border-[2.5px] border-[2.5px] border-[#fff] 
                          lg:text-[16px] md:text-[18px] sm:text-[11px] text-[14px]
                         md:leading-[46.09px] sm:leading-[22.8px] 
                          leading-[26px]  text-[#ffff] font-[700] 
                          font-hanken-grotesk sm:static absolute right-[35px] top-[22px]"
                data-te-ripple-init
                onClick={() => {
                  if (currentPath === "/Savings") {
                  }
                  else if (currentPath === "/home") {
                    logFirebaseEvents("Home", "Add_Money_Clicked", "Add_Money_Clicked", "");
                  }
                  else {
                    logFirebaseEvents("Spendings", "Add_Money_Clicked", "Add_Money_Clicked", "");
                  }
                  global.selectedAccountServiceCardKey = cardDetails.CardKey
                  const transferPath = cardDetails.AccountTypeBit63 === 1 ? '/AccountServices/smiONECard/TransferMoney' : cardDetails.AccountTypeBit63 === SAVING_CARD_CODE ? '/AccountServices/Savings/TransferMoney' : '/AccountServices/Spending/TransferMoney';
                  const transferSubIndex = cardDetails.AccountTypeBit63 === SAVING_CARD_CODE ? 0 : 1;
                  dispatch({ type: 'SELECTED_SUB_INDEX', payload: { selectedSubIndex: transferSubIndex } });
                  navigate(transferPath);
                }}> {t('addMoneyTittle')} </button>
            )
          }
          </div>
       )}

       
      </div>
              {cardDetails.AccountTypeBit63 !== 1 &&
                  location.pathname !== '/Transactions' && (
                      <Link to={'/Toolkit/SavingGoals/ManageSavingGoal'}>
                          {displayManageText && (
                          <span className="md:float-right lg:float-right sm:float-start uppercase text-[#94C3E8] md:text-[12px] sm:text-[11px] font-normal font-hanken-grotesk p-2 tracking-[2px] whitespace-nowrap">
                                  {t('manageSavingsGoals')}
                              </span>
                          )}
                      </Link>
                  )}

     
     
      </div>
      <div className="sm:hidden block">
        {showAccountDetails &&
          <>
            <AccountDetailsHeder
              mblaccountDetails={true}
              AccountNo={accountNumber}
              routingNo={routingNumber}
              handleCopyClick={handleCopyClick}
              handleCopyRoutingNumberClick={handleCopyRoutingNumberClick}
              contentBetween={true}
              topBorder={false}
              bottomBorder={true}
              isCopyblack={true} />
            {currentPath === '/' + SPENDING + '' && (
              <div className='h-auto'>
                <div className='px-2 pb-4 flex justify-between flex-row gap-y-4 w-full flex-wrap'>
                  {cardOptionsList != [] &&
                    cardOptionsList.map((item, index) => (
                      <button
                        type="button"
                        className={CardButton}
                        data-te-ripple-init
                        onClick={() => { handleCardAction(item.name) }}
                      >
                        {item.name} 
                      </button>
                    ))
                  }
                </div>
              </div>
            )}
          </>
        }
      </div>

      {/* Account Switcher Modal */}
      {showAccountModal && (
        <CustomAlertModel
          isOpen={showAccountModal}
          onClose={closeAccountModal}
          highlightMsg={
            <p className="font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] text-center font-normal text-[var(--add-extr-acc-high-clr)]">
              Select an Account
            </p>
          }
          subHeaderMsg={
            <div className="flex flex-col gap-4 w-full mt-6">
              {hasSpendingAccount && (() => {
                const spendingCard = getSpendingCard();
                return (
                  <>
                    <div
                      onClick={() => handleAccountSelect('spending')}
                      className={`relative px-5 py-4 cursor-pointer bg-white border-radius-45 hover:border-[#2965FB] flex items-center justify-between transition-colors rounded-lg border-2 ${
                        cardDetails.AccountTypeBit63 === CHECKING_CARD_CODE ? 'border-[#2965FB]' : 'border-gray-200'
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        <img 
                          src={kudzuPlusTrue ? ModalLogo_kudzplus : ModalLogo} 
                          alt="Kudzu Logo" 
                          className="w-4 h-4"
                        />
                        <div className="flex items-center gap-2">
                          <span className="text-gray-800 font-hanken-grotesk text-[16px] font-semibold">
                            {spendingCard?.AccountTypeName || 'Spending Account'}
                          </span>
                          <span className="text-gray-600 font-hanken-grotesk text-[14px] flex items-center">
                            {getMaskedCardNumber(spendingCard?.CardDisplayNumber || '')}
                          </span>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <span className="text-gray-800 font-hanken-grotesk text-[18px] font-bold">
                          {formatAmount(spendingCard?.Balance)}
                        </span>
                      </div>
                    </div>
                  </>
                );
              })()}
              {hasSavingsAccount && (() => {
                const savingsCard = getSavingsCard();
                return (
                  <div
                    onClick={() => handleAccountSelect('savings')}
                        className={`relative px-5 py-4 cursor-pointer bg-white border-radius-45 hover:border-[#2965FB] flex items-center justify-between transition-colors rounded-lg border-2 ${
                      cardDetails.AccountTypeBit63 === SAVING_CARD_CODE ? 'border-[#2965FB]' : 'border-gray-200'
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <img 
                        src={kudzuPlusTrue ? ModalLogo_kudzplus : ModalLogo} 
                        alt="Kudzu Logo" 
                        className="w-4 h-"
                      />
                      <div className="flex items-center gap-2">
                        <span className="text-gray-800 font-hanken-grotesk text-[16px] font-semibold">
                          {savingsCard?.AccountTypeName || 'Savings Account'}
                        </span>
                        <span className="text-gray-600 font-hanken-grotesk text-[14px] flex items-center">
                          {getMaskedCardNumber(savingsCard?.CardDisplayNumber || '')}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <span className="text-gray-800 font-hanken-grotesk text-[18px] font-bold">
                        {formatAmount(savingsCard?.Balance)}
                      </span>
                    </div>
                  </div>
                );
              })()}
            </div>
          }
          btn1Exists={false}
          btn2Exists={false}
          isBorderNone={true}
        />
      )}
    </div>
  );
};

///for home page MM-DD-YYYY
export const formatDateToMMDDYYYY = (dateString, separator) => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  const result = separator ? `${month}${separator}${day}${separator}${year}` : `${month}-${day}-${year}`;

  return result;

};
export const formatDateToMMDDYY = (dateString, separator) => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear() % 100;
  const result = separator ? `${month}${separator}${day}${separator}${year}` : `${month}-${day}-${year}`;

  return result;

};

export const formatDateToMonthDayYear = (inputDateStr, isDayOfWeek = true) => {
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const inputDate = new Date(inputDateStr);
  const dayOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][inputDate.getDay()];
  const month = months[inputDate.getMonth()];
  const day = inputDate.getDate();
  const year = inputDate.getFullYear();

  const result = isDayOfWeek ? `${dayOfWeek}, ${month} ${day}, ${year}` : `${month} ${day}, ${year}`

  return result;
}

export const dateComparison = (inputDate) => {
   debugger;
  // const inputDateObj = new Date(new Date().toUTCString().substr(0, 25));
  const currentDate = new Date();
  const inputDateObj = new Date(inputDate);
  console.log("currentDate", currentDate)
  console.log("inputDateObj", inputDateObj)
  console.log("inputDate", inputDate)
  // Set the time to midnight to compare only dates
  currentDate.setHours(0, 0, 0, 0);
  inputDateObj.setHours(0, 0, 0, 0);
  // if(moment(`${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`).isSame(`${currentDate.getFullYear()}-${('0' + (currentDate.getMonth() + 1)).slice(-2)}-${('0' + currentDate.getDate()).slice(-2)}`)){
  //   return "Today";
  // }
  // else if(moment(`${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`).isBefore(`${currentDate.getFullYear()}-${('0' + (currentDate.getMonth() + 1)).slice(-2)}-${('0' + currentDate.getDate()).slice(-2)}`)){
  //   return "Past";
  // }
  // else{
  //   return "Future"
  // }
  console.log("currentDate", currentDate.toDateString())
  console.log("inputDateObj", inputDateObj.toDateString())

  if (inputDateObj.toDateString() === currentDate.toDateString()) {
    return "Today";
  } else if (inputDateObj > currentDate) {
    return "Future";
  } else {
    return "Past";
  }
}




export const parseDateFromString = (dateString) => {
  const [month, day, year] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return date;
};

// HH:MM AM/PM
export const getTimeFromDate = (dateString) => {
  try {
    const dateObj = new Date(dateString);
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  } catch (error) {
    return null;
  }
}

// HH:MM AM/PM
export const convertToTimeFormat = (timeString) => {
  try {
    const [hours, minutes] = timeString.split(":").map(Number);
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  } catch (error) {
    return null;
  }
}

export const convertToMinutesSinceMidnight = (timeString) => {
  const [time, ampm] = timeString.split(" ");
  const [hours, minutes] = time.split(":").map(Number);
  return hours % 12 * 60 + minutes + (ampm.toLowerCase() === "pm" ? 12 * 60 : 0);
}

export const convertFromMinutesSinceMidnight = (minutes) => {
  const hours = Math.floor(minutes / 60) % 12 || 12;
  const minutesOfDay = minutes % 60;
  const ampm = minutes < 720 ? "AM" : "PM";
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutesOfDay.toString().padStart(2, "0");
  return `${formattedHours}:${formattedMinutes} ${ampm}`;
}

export const convertTo24HourFormat = (timeString) => {
  const [time, ampm] = timeString.split(" ");
  const [hours, minutes] = time.split(":").map(Number);

  let hours24 = hours % 12; // Convert to 24-hour format
  if (ampm.toLowerCase() === "pm") {
    hours24 += 12; // Add 12 hours for PM times (except 12 PM)
  }

  const formattedHours = hours24.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}`;
}

export const compareTime = (time1, time2) => {
  const minutes1 = convertToMinutesSinceMidnight(time1);
  const minutes2 = convertToMinutesSinceMidnight(time2);

  if (minutes1 < minutes2) {
    return -1; // time1 is before time2
  } else if (minutes1 > minutes2) {
    return 1; // time1 is after time2
  } else {
    return 0; // time1 is equal to time2
  }
}
export const timeDiffernce = (time1, time2) => {
  const minutes1 = convertToMinutesSinceMidnight(time1);
  const minutes2 = convertToMinutesSinceMidnight(time2);

  if (minutes1 < minutes2) {
    return (minutes2 - minutes1)
  } else {
    return (minutes1 - minutes2)
  }
}

export const convertTimestamp = (timestamp, isHome = false) => {
  // Convert the input timestamp to a Date object
  const givenTime = new Date(timestamp);

  // Get the current time in UTC
  // "2023-10-25T23:59:00"
  const currentDate = new Date();
  const compareDateTo = `${currentDate.getFullYear()}-${('0' + (currentDate.getMonth() + 1)).slice(-2)}-${('0' + currentDate.getDate()).slice(-2)}T23:59:00`
  const currentTime = new Date(compareDateTo);

  // Calculate the time difference between the given time and the current time in milliseconds
  const timeDifference = currentTime.getTime() - givenTime.getTime();

  // Calculate the days and weeks difference
  const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
  const weeksDifference = Math.floor(daysDifference / 7);

  // Get the time part of the given timestamp (without date)
  const timePart = givenTime.toLocaleTimeString("en-US", {
    hour12: true,
    hourCycle: "h24",
    hour: "numeric",
    minute: "numeric",
    // timeZone: "America/New_York", // Replace with your desired time zone
  });

  if (isHome) {
    if (weeksDifference < 1) return "lessThan7days";
  }

  if (weeksDifference === 1) {
    return "1 week ago";
  } else if (weeksDifference > 1) {
    return weeksDifference + " weeks ago";
  } else if (daysDifference === 1) {
    return "Yesterday at " + timePart;
  } else if (daysDifference > 1) {
    return daysDifference + " days ago";
  } else {
    return "Today at " + timePart + " ET";
  }
}

// export const handleAmountInputLimitTo2decimal = (amount) => { 
//   const formattedAmount = amount.replace(/[^\d.]/g, '') 
//     .replace(/^(\d+\.?)(.*)$/, ($0, $1, $2) =>  
//     {
//       console.log($0, $1, $2)
//       if (!$2) return `${$1}`
//       else return `${$1}${$2.replaceAll('.', '').slice(0, 2)}`
//     }
//     )
//   return formattedAmount;
// }
export const handleAmountInputLimitTo2decimal = (amount) => {
  const cleanedAmount = amount.replace(/[^\d.]/g, '');
  const noLeadingZeros = cleanedAmount.replace(/^0(?!\.|$)/, '');
  const formattedAmount = noLeadingZeros.replace(/^(\d+\.?)(.*)$/, ($0, $1, $2) => {
    if (!$2) return `${$1}`;  
    return `${$1}${$2.replaceAll('.', '').slice(0, 2)}`; 
  });

  return formattedAmount;
};

export const formatPhoneNumber = (number) => {
  if (!number) return "";
  const cleaned = ("" + number).replace(/\D/g, ""); 
  if (cleaned.length !== 10) return number; 
  return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6, 10)}`;
};

export const handleAmountInputLimitTo2decimalForAmount = (amount) => {
  let sanitizedAmount = amount.replace(/[^0-9.]/g, '');

  // Ensure only one decimal point exists
  const parts = sanitizedAmount.split('.');
  if (parts.length > 2) {
    sanitizedAmount = `${parts[0]}.${parts[1]}`; // Keep only the first two parts
  }

  // Restrict decimal places to two
  if (sanitizedAmount.includes('.')) {
    const [integerPart, decimalPart] = sanitizedAmount.split('.');
    sanitizedAmount = `${integerPart}.${decimalPart.slice(0, 2)}`;
  }

  return sanitizedAmount;
};



export const createTinkUrl = (baseUrl, clientId, redirectUri) => {
  const url = new URL(baseUrl);
  url.searchParams.append('client_id', clientId);
  url.searchParams.append('redirect_uri', redirectUri);
  url.searchParams.append('market', 'US');
  url.searchParams.append('locale', 'en_US');
  url.searchParams.append('iframe', true);
  url.searchParams.append('refreshable_items', 'IDENTITY_DATA,CHECKING_ACCOUNTS,SAVING_ACCOUNTS');
  console.log("url----", url.href)
  return url.href;

}

export const copyToClipboard = (text, setCopiedState) => {
  //debugger;
  const textarea = document.createElement('textarea');
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
};


const sidemenuItem = 'cursor-pointer font-hanken-grotesk font-[600] lg:text-[16px] md:text-[14px] sm:text-[14px] text-[15px] leading-[20px] md:font-[700] md:leading-[16px] lg:leading-[16px] text-[#FEFAEE]';
export const ClimbMenuSidebar = () => {
  const navigate = useNavigate();
  return (
    <div className='lg:w-[210px] md:w-[270px] sm:w-[163px] w-full sm:mx-0 ml-[2.5rem]'>

      <p style={{width:"293px"}} className="text-[#94C3E8] font-normal text-[25px]
       lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px]
  leading-[30px] md:leading-[33px] lg:leading-[38px] font-serif-pro border-b-[2.5px]
   border-[#4B70B9]  lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10  border-opacity-[50%] w-[80%] sm:w-full text-[25px]">



        <span className="text-white"> {addLineBreaks(t("Which_tool_would"))} </span>
        </p>

      <div className='flex flex-col md:gap-10 gap-8 sm:pb-0 pb-10'>
        <Link to="/Toolkit/ToolkitSettings" className={sidemenuItem}>
          {/* {t("Manage_Settings")} */}
          {t('Settings')}
        </Link>
      </div>
    </div>

  )
}
export const ClimbManageSettingsSidebar = ({ indexBtn, ManageSettingsbuttonLabels, count, headingMessage, isShow = true, navigateClicked }) => {
  // const climbFeatures = useSelector(state => state.climbFeatures);
  // const enabledClimbings = climbFeatures.filter((response) => response.enabled === true);
  // const isCoveredByKudzuOptedIn = enabledClimbings.some(item => item.code === 'CoveredByKudzu' && item.optedIn)

  // debugger
  const navigate = useNavigate();
  const location = useLocation();



  const normalBtn = "md:w-[210px] sm:w-[166px] w-full lg:text-[16px] md:text-[14px] sm:text-[14px] text-[15px] text-[#94C3E8] font-hanken-grotesk font-[700] h-[50px] border-[var(--climb-sidebar-border-clr)] border-[2.5px] border-opacity-[25%] rounded-[36px]"
  const highlightBtn = "md:w-[210px] sm:w-[166px] w-full lg:text-[16px] md:text-[14px] sm:text-[14px] text-[15px] font-hanken-grotesk font-[700] h-[50px] border-[#4B70B9] border-[2.5px] border-opacity-[25%] rounded-[36px] bg-[#4B70B9] text-white"

  return (
    <>
      <div className=" flex  flex-col justify-center items-center w-full sm:flex-none sm:justify-normal sm:item-start sm:w-auto">
        <div className='lg:w-[282px] md:w-[250px] sm:w-[163px] w-[264px]'>
          {/* <div className='lg:w-[282px] md:w-[250px] sm:w-[163px] w-[264px] sm:mx-0 ml-[2.5rem]'> */}
          <p  className="text-[#FFFF] font-normal
          lg:text-[32px] md:text-[25px] sm:text-[21px] text-[20px] 
          leading-[30px] md:leading-[33px] lg:leading-[38px] font-serif-pro border-b-[2.5px]
          border-[#4B70B9] lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10  border-opacity-[50%]">
            {headingMessage ? (
              t('Which_tool_would')
            ) : (
              (location.pathname.toLowerCase() == '/climb/managesavingshabit' || location.pathname.toLowerCase().includes('climb/savingshabit/edithabit')) ? (
                t('active_alerts_savings_habit').replace("{ACTIVE_ALERTS}", (count !== undefined && isShow) ? count : 0)
              ) : (location.pathname.toLowerCase() == '/climb/savinggoals/managesavinggoal' || location.pathname.toLowerCase() == '/climb/savinggoals/managesavinggoal/managesavinggoaldetails'  || location.pathname.toLowerCase() == '/climb/savinggoals/managesavinggoal/edit')  ? (
                t('Saving_Goal_active_alerts').replace("{ACTIVE_ALERTS}", (count !== undefined && isShow) ? count : '0')
              ) : (
                t('active_alerts').replace("{ACTIVE_ALERTS}", (count !== undefined && isShow) ? count : 0)
              ) 
            )}
      
          </p>
          <div className="pb-6 flex flex-col gap-6">
            {ManageSettingsbuttonLabels.map((item, index) => (
              <button
                key={index}
                className={`${indexBtn === index + 1 ? highlightBtn : normalBtn}`}
                // ${((item.label == 'Covered by Kudzu' && isCoveredByKudzuOptedIn) ? 'opacity-50 cursor-not-allowed' : '')}
                // onClick={() => {navigate(item.link)}}
                onClick={() => navigateClicked(item)}
              // disabled={((item.label == 'Covered by Kudzu' && isCoveredByKudzuOptedIn) ? true : false)}
              >
                {item.label}
              </button>
            ))}
          </div>

          <div className="bg-[#4B70B9] h-[2px] opacity-[50%] mb-10"></div>
          <div className='flex flex-col md:gap-10 gap-8 sm:pb-0 pb-10'>
            <Link to="/Toolkit/ToolkitSettings" className={`cursor-pointer font-hanken-grotesk font-[600] lg:text-[16px] md:text-[14px] sm:text-[14px] text-[15px] leading-[20px] md:font-[700] md:leading-[16px] lg:leading-[16px] text-[#fff]`}>
              {/* {t("Manage_Settings")} */}
              {t('Settings')}
            </Link>
          </div>
        </div>

      </div>
      <div className='md:w-[150px] sm:w-[70px] w-[0px]'></div>
    </>
  )
};

export const ClimbCard = ({ image, heading, subheading, buttonText, backgrounblue, RadiusTrue, disabled, navigateClick, note, savingsCardExist }) => {
  const navigate = useNavigate(); 
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
  const appThemeData = appTheme(kudzuPlusTrue) 
  const isAlwaysEnabled = false;
  return (
    <>
      <div className={`${backgrounblue ? 'bg-[var(--climbMenuCardevenBg)]' : 'bg-[var(--climbMenuCardoddBg)]'}
       ${RadiusTrue ? 'rounded-tl-[4rem] rounded-br-[4rem]' : 'rounded-tr-[4rem] rounded-bl-[4rem]'} 
        flex flex-col md:py-20 py-16`}>
        <div className="flex justify-center">
          <div className='flex sm:justify-between justify-center sm:gap-0 gap-6 items-center md:w-[85%] sm:w-[90%] w-full'>
            <div>
              <img alt={image} src={image} className="lg:w-[120px] lg:h-[120px] md:w-[90px] md:h-[90px] sm:w-[64px]
               sm:h-[64px] h-[65px] w-[65px]" />
            </div>
            <div>
              <p className="lg:text-[28px] md:text-[28px] sm:text-[15px] text-[16px] font-hanken-grotesk
               md:leading-[28px] sm:leading-[23px] font-[500] sm:font-[600] md:font-[500] sm:w-auto
              w-[127px] leading-[24px] text-[var(--transferSubHeading-text)]">{heading}</p>
              {/* <p className="lg:w-[324px] md:w-[262px] w-[228px] lg:mt-4
               sm:mt-2 mt-3 md:text-[18px] sm:text-[10px] text-[16px] font-hanken-grotesk
               md:leading-[28px] sm:leading-[16px] font-[500] sm:block hidden">{createSuperscript("hi", [2,3,4])}</p> */}
              <p className="lg:w-[324px] md:w-[262px] w-[228px] lg:mt-4
               sm:mt-2 mt-3 md:text-[18px] sm:text-[10px] text-[16px] font-hanken-grotesk
               md:leading-[28px] sm:leading-[16px] font-[500] sm:block hidden  
               text-[var(--transferSubHeading-text)]">{subheading}</p>
              {note &&
                <p className="sm:block hidden md:font-[400] md:text-[12px] md:leading-[20px] sm:font-[500] sm:text-[10px] sm:leading-[16px] mt-8 text-[var(--climbNoteTextColor)]">{note}</p>
              }
              <button
                className={`sm:mt-0 mt-4 lg:h-[55px] md:h-[50px] sm:h-[36px] h-[40px]
                lg:w-[180px] md:w-[120px] sm:w-[90px] w-[120px] lg:text-[16px] md:text-[14px] sm:text-[14px] text-[13px] font-[700] text-white rounded-[74px] sm:hidden flex  justify-center 
                items-center font-hanken-grotesk ${disabled ? 'opacity-50 cursor-not-allowed borderGradient' : 'borderGradient'}`}
                disabled={disabled}
                onClick={() => {
                  if (typeof navigateClick == 'function') {
                    navigateClick(); // If it's a function, call it
                  } else if (navigateClick) {
                    navigate(navigateClick); // If it's a URL or some other value, use it with `navigate`
                  }
                }}
              >
                {buttonText} {(savingsCardExist != undefined && savingsCardExist == false && heading !== 'SpendSense Alerts') ? <img src={lock} className="ml-2 sm:w-auto w-[13px]" alt="Check" /> : ((heading === 'Covered by Kudzu' || heading === 'Covered by Kudzu Plus') && disabled) && <img src={Check} alt="check" className="ml-2 sm:w-auto w-[13px]" />}
              </button>
            </div>
            <button
               className={`lg:h-[55px] md:h-[50px] sm:h-[36px] h-[40px]
                lg:w-[180px] md:w-[120px] sm:w-[90px] w-[150px] lg:text-[17px] md:text-[15px] sm:text-[12px]
                text-[14px] font-[700] text-white rounded-[74px] sm:flex hidden justify-center 
                items-center font-hanken-grotesk
                ${kudzuPlusTrue 
                  ? (!disabled || isAlwaysEnabled 
                      ? 'borderGradient cursor-pointer' 
                      : 'opacity-50 cursor-not-allowed bg-[#262B3A]') 
                  : (!disabled || isAlwaysEnabled 
                      ? 'bg-[#2965FB] cursor-pointer' 
                      : 'opacity-50 cursor-not-allowed bg-[#4B70B9]')}
              `}
              disabled={disabled}
              onClick={() => {
                if (typeof navigateClick == 'function') {
                  navigateClick(); // If it's a function, call it
                } else if (navigateClick) {
                  navigate(navigateClick); // If it's a URL or some other value, use it with `navigate`
                }
              }}
            >
              {buttonText} {(savingsCardExist != undefined && savingsCardExist == false && heading !== 'SpendSense Alerts') ? <img src={lock} className="ml-2" alt="Check" /> : ((heading === 'Covered by Kudzu' && disabled === true) || (heading === 'Covered by Kudzu Plus' && disabled === true)) && <img src={Check} className="ml-2" alt="Check" />}
            </button>  
          </div>
        </div>
      </div>
    </>
  )
};

export const ClimbCardPlus = ({
  image,
  heading,
  subheading,
  buttonText,
  backgroundColor,
  RadiusTrue,
  disabled,
  navigateClick,
  note,
  savingsCardExist,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className={`${backgroundColor ? 'bg-[#2F3C59]' : 'bg-[#FFFFFF]'
          } ${RadiusTrue
            ? 'rounded-tl-[4rem] rounded-br-[4rem]'
            : 'rounded-tr-[4rem] rounded-bl-[4rem]'
          } flex flex-col md:py-20 py-16`}
      >
        <div className="flex justify-center">
          <div className="flex flex-col sm:flex-row sm:justify-between justify-center sm:gap-0 gap-6 items-center md:w-[85%] sm:w-[90%] w-full">
            {/* Image */}
            <div>
              <img
                alt={image}
                src={image}
                className="lg:w-[90px] lg:h-[90px] md:w-[70px] md:h-[70px] sm:w-[50px] sm:h-[50px] w-[50px] h-[50px]"
              />
            </div>

            {/* Text */}
            <div className="text-center sm:text-left">
              <p
                className="lg:text-[28px] md:text-[28px] sm:text-[15px] text-[16px] font-hanken-grotesk
               md:leading-[28px] sm:leading-[23px] font-[500] sm:font-[600] md:font-[500] sm:w-auto w-[127px] leading-[24px] text-white"
              >
                {heading}
              </p>
              <p
                className="lg:w-[324px] md:w-[262px] w-[228px] lg:mt-4
               sm:mt-2 mt-3 md:text-[18px] sm:text-[10px] text-[16px] font-hanken-grotesk
               md:leading-[28px] sm:leading-[16px] font-[500] sm:block hidden"
              >
                {subheading}
              </p>
              {note && (
                <p
                  className="sm:block hidden md:font-[400] md:text-[12px] md:leading-[20px] sm:font-[500] sm:text-[10px] sm:leading-[16px] mt-8 text-[#4B70B9]"
                >
                  {note}
                </p>
              )}
            </div>

            {/* Button */}
            <div className="relative">
              <button
                className={`relative z-10 lg:h-[55px] md:h-[50px] sm:h-[36px] h-[40px] mt-4 sm:mt-0
              lg:w-[180px] md:w-[120px] sm:w-[90px] w-[150px] lg:text-[17px] md:text-[15px] sm:text-[12px]
              text-[14px] font-[700] text-white rounded-[74px] flex pl-6
              items-center font-hanken-grotesk ${disabled ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
                disabled={disabled}
              // onClick={() => {
              //   if (typeof navigateClick === 'function') {
              //     navigateClick(); // If it's a function, call it
              //   } else if (navigateClick) {
              //     navigate(navigateClick); // If it's a URL or some other value, use it with `navigate`
              //   }
              // }}
              >
                <img src={lock} alt="lock Icon" className="mr-4 w-4" />
                {buttonText}
                {savingsCardExist !== undefined &&
                  savingsCardExist === false &&
                  heading !== 'SpendSense Alerts' ? (
                  <img src={lock} alt="lock" />
                ) : (heading === 'Covered by Kudzu' || heading === 'Covered by Kudzu Plus') && disabled ? (
                  <img src={Check} className="ml-2" alt="Check" />
                ) : null}
              </button>
              {/* Button Border Image */}
              <img
                src={Radiantborder}
                alt="Button image"
                className="absolute top-0 left-0 w-full h-full z-0"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};



export const AccountDetailsHeder = ({ AccountNo, routingNo, accountCopiedProps, routingCopiedProps,
  handleCopyClick, handleCopyRoutingNumberClick, contentBetween, topBorder, bottomBorder, isblock,
  isCopyblack, mblaccountDetails }) => {

  const { t } = useTranslation();
  const [ContentSpace] = useState(contentBetween);
  const [BorderTop] = useState(topBorder);
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);

  const appThemeData = appTheme(kudzuPlusTrue)

  // const [BorderBottom] = useState(bottomBorder);

  ///////styles 
  const AccountRoutingText = 'md:font-[600]  lg:text-[16px] md:text-[16px] sm:text-[11px]  font-[500] sm:text-[var(--text-clr-transactions-copy-number)] text-[var(--mbltext-clr-transactions-copy-number)] leading-[16px] font-hanken-grotesk md:pb-8 sm:pb-4';
  const AccountRoutingNum = 'font-[700] text-[var(--text-clr-transactions-acc-number)] sm:font-[700] md:text-[16px] sm:text-[12px] text-[12px]  leading-[16px] tracking-[2px] sm:flex';

  // Reusable copy button component
  const CopyButton = ({ onClick, altText, isHidden = false }) => (
    <button
      type="button"
      onClick={onClick}
      className={`${isHidden ? 'sm:hidden' : 'sm:block hidden'} ${isHidden ? 'float-right block ml-3' : 'ml-2'} tracking-[0px] cursor-pointer bg-transparent border-none p-0 inline-flex items-center`}
      aria-label={altText}
    >
      <img 
        src={kudzuPlusTrue ? Copy_Text_Plus : Copy_Text} 
        alt={altText}
        className={isHidden ? '' : 'lg:w-[14px] md:w-[14px] sm:w-[12px] inline-block'}
      />
    </button>
  );

  return (
    <>
      {mblaccountDetails ? (
        <>
          <div className="flex justify-between py-10">
            <div class="h-[50px] sm:block flex justify-between flex-col">
              <p class="font-[600] text-[#FFFFFF] text-[12px] leading-[16px] font-hanken-grotesk 
             md:pb-8 sm:pb-4">{t("accounting_number")}</p>
              <p class="font-[600] text-[#FFFFFF] 
             md:text-[16px] sm:text-[13px] text-[12px]  
             leading-[16px] tracking-[2px] sm:flex" style={{ fontFamily: 'Space Mono' }}>
                {AccountNo}
                <CopyButton 
                  onClick={handleCopyClick} 
                  altText={t("copy_account_number")}
                  isHidden={true}
                />
              </p>
            </div>

            <div class="h-[50px] sm:block flex justify-between flex-col">
              <p class="font-[600] text-[#FFFFFF] text-[12px] leading-[16px] font-hanken-grotesk 
             md:pb-8 sm:pb-4">{t("routing_number")}</p>
              <p class="font-[600] text-[#FFFFFF] 
             md:text-[16px] sm:text-[13px] text-[12px]  
             leading-[16px] tracking-[2px] sm:flex" style={{ fontFamily: 'Space Mono' }}>
                {routingNo}
                <CopyButton 
                  onClick={handleCopyRoutingNumberClick} 
                  altText={t("copy_routing_number")}
                  isHidden={true}
                />
              </p>
            </div>
          </div>
        </>
      ) :
        <div className={`border-opacity-[50%] lg:h-[216px] md:h-[190px] sm:h-[150px] h-[258px] flex flex-col justify-center
     ${BorderTop ? 'border-t-[2.5px] border-[var(--transactions-acc-number-border)]' : ''}
     ${bottomBorder ? 'border-b-[2.5px] border-[var(--transactions-acc-number-border)]' : ''}
     ${ContentSpace ? 'sm:mx-0 mx-4' : 'lg:ml-[11%] md:ml-[10%] sm:ml-[8%] sm:mr-0 mx-4'}`}>
          <p className={`sm:block hidden font-hanken-grotesk text-[var(--primary-text-cards)] 
      uppercase  lg:text-[13px] md:text-[12px] sm:text-[9px] text-[13px]
      font-[600] tracking-[2px] md:pb-8 pb-5 
      ${isblock ? 'opacity-1' : ''}
      `}>{t("account_info").toLocaleUpperCase()}</p>


          <div className={`sm:flex ${ContentSpace ? '' : 'gap-[7rem]'}`}>
            <div className={`${ContentSpace ? 'sm:w-1/2 w-full' : 'sm:w-auto w-full'} sm:h-0 h-[65px] sm:block flex justify-between flex-col sm:mb-0 mb-12`}>
              <p className={`${AccountRoutingText} ${kudzuPlusTrue ? 'opacity-100  text-[12px]  sm:tracking-[0px] tracking-[2px]  sm:capitalize uppercase' : 'sm:opacity-100 opacity-[50%] text-[10px]  '}`} >{t("accounting_number")}</p>
              <p className={AccountRoutingNum} style={{ fontFamily: 'Space Mono' }}>{AccountNo}
                 {AccountNo === "--" ? (
                  <></> 
                 ) :(
                  <>
                    <CopyButton 
                      onClick={handleCopyClick} 
                      altText={t("copy_account_number")}
                      isHidden={false}
                    />
                    <CopyButton 
                      onClick={handleCopyClick} 
                      altText={t("copy_account_number")}
                      isHidden={true}
                    />
                  </>
                 )}             
              </p>
              {(accountCopiedProps) &&
                <p className='font-[600] text-[#2864fa] text-left text-[16px] 
                leading-[16px] font-hanken-grotesk pt-4 '>{t('copied')}</p>
              }
            </div>

            <div className={`${ContentSpace ? 'sm:w-1/2 w-full' : 'sm:w-auto w-full'}sm:h-0 h-[65px] sm:block flex justify-between flex-col`}>
              <p className={`${AccountRoutingText} ${kudzuPlusTrue ? 'opacity-100  text-[12px] sm:tracking-[0px] tracking-[2px] sm:capitalize uppercase' : 'sm:opacity-100 opacity-[50%] text-[10px]  '}`} >{t("routing_number")}</p>
              <p className={AccountRoutingNum} style={{ fontFamily: 'Space Mono' }}>{routingNo}
                {routingNo === "--" ? (
                  <></>
                ) : (
                  <>
                    <CopyButton 
                      onClick={handleCopyRoutingNumberClick} 
                      altText={t("copy_routing_number")}
                      isHidden={false}
                    />
                    <CopyButton 
                      onClick={handleCopyRoutingNumberClick} 
                      altText={t("copy_routing_number")}
                      isHidden={true}
                    />
                  </>
                )}

              </p>
              {(routingCopiedProps) &&
                <p className='font-[600] text-[#2864fa] text-left text-[16px] leading-[16px] font-hanken-grotesk pt-4 '>{t('copied')}</p>
              }
            </div>
          </div>
        </div>
      }
    </>
  );
};

export const ManageSavingsGoal = ({ savingGoalValues, contentBetween, topBorder, bottomBorder}) => {

  console.log(savingGoalValues.at(0).total_savings);
  const navigate = useNavigate();


  const valueSplitter = (amount) => {
    const stringValue = amount.toString();
  const parts = stringValue.split('.');

  const beforeDecimal = parts[0]; // "100"
  const afterDecimal = parts[1] || '0'; // "5"

  let formattedValue = `${beforeDecimal}.`;

  // Add zeros based on the decimal part count
  if (afterDecimal.length === 1) {
    formattedValue += `${afterDecimal}0`; // "100.50"
  } else if (afterDecimal.length === 0) {
    formattedValue += '00'; // "100.00"
  } else {
    formattedValue += afterDecimal; // "100.5" (if there are more than one decimal places)
  }


  const balnceSplit = formattedValue.toString().split('.');
  return balnceSplit;
  }

  const { t } = useTranslation();
  const [ContentSpace] = useState(contentBetween);
  const [BorderTop] = useState(topBorder);
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);

  const appThemeData = appTheme(kudzuPlusTrue)

  // const [BorderBottom] = useState(bottomBorder);

  const handleManageNavigate =() =>{
    navigate('/Toolkit/SavingGoals/ManageSavingGoal')
  }

  return (
    <>
        <div className={`border-opacity-[50%] lg:h-[216px] md:h-[190px] sm:h-[150px] h-[258px] flex flex-col justify-center
     ${BorderTop ? 'border-t-[2.5px] border-[var(--transactions-acc-number-border)]' : ''}
     ${bottomBorder ? 'border-b-[2.5px] border-[var(--transactions-acc-number-border)]' : ''}
     ${ContentSpace ? 'sm:mx-0 mx-4' : 'lg:ml-[11%] md:ml-[10%] sm:ml-[8%] sm:mr-0 mx-4'}`}>
      <div className="flex justify-between items-center">
      <p className={`sm:block hidden font-hanken-grotesk text-[var(--primary-text-cards)] 
      uppercase  lg:text-[13px] md:text-[12px] sm:text-[9px] text-[13px]
      font-[600] tracking-[2px] md:pb-8 pb-5 
      `}>{t("manage_goals").toLocaleUpperCase()}</p>
        {/* <button></button> */}
        <Link to="/Toolkit/SavingGoals/ManageSavingGoal" className="inline-block">
          <img
                src={Next}
                alt="next"
                className="md:w-[auto] sm:w-[12px] cursor-pointer mt-[-35px]"
              />
        </Link>
      </div>
       


          {/* <div className={`flex justify-between`}>
            <div className={`flex md:font-[500] sm:font-[400] font-[500]
              md:leading-[56px] sm:leading-[28.38px] leading-[37.49px]  text-[var(--total-savings-color)] sm:ml-4
              ml-0 font-hanken-grotesk `}>
            <div className="lg:text-[41px] md:text-[40px] sm:text-[23px] text-[44px]">${valueSplitter(savingGoalValues.at(0).totalSavingsBalance)[0]}</div>
            <div className="lg:text-[36px] md:text-[30px] sm:text-[20px] text-[35px] lg:mt-[-12px] md:mt-[-7px] sm:mt-[-5px] mt-[-11px] md:font-[500] font-[300]">.</div>
            <div className='lg:text-[25px] md:text-[23px] sm:text-[15px] text-[22px] lg:mt-[-6px] md:mt-[-4px] sm:mt-[-3px] mt-[-5px] md:font-[500] font-[300]
                font-hanken-grotesk'>{valueSplitter(savingGoalValues.at(0).totalSavingsBalance)[1]}</div>
            </div>
            <div className={`flex md:font-[500] sm:font-[400] font-[500]
              md:leading-[56px] sm:leading-[28.38px] leading-[37.49px]  text-[var(--total-savings-color)] sm:ml-4
              ml-0 font-hanken-grotesk `}>
            <div className="lg:text-[41px] md:text-[40px] sm:text-[23px] text-[44px]">${valueSplitter(savingGoalValues.at(0).totalSavingsBalance)[0]}</div>
            <div className="lg:text-[36px] md:text-[30px] sm:text-[20px] text-[35px] lg:mt-[-12px] md:mt-[-7px] sm:mt-[-5px] mt-[-11px] md:font-[500] font-[300]">.</div>
            <div className='lg:text-[25px] md:text-[23px] sm:text-[15px] text-[22px] lg:mt-[-6px] md:mt-[-4px] sm:mt-[-3px] mt-[-5px] md:font-[500] font-[300]
                font-hanken-grotesk'>{valueSplitter(savingGoalValues.at(0).totalSavingsBalance)[1]}</div>
            </div>
            <div className={`flex md:font-[500] sm:font-[400] font-[500]
              md:leading-[56px] sm:leading-[28.38px] leading-[37.49px]  text-[var(--total-savings-color)] sm:ml-4
              ml-0 font-hanken-grotesk `}>
            <div className="lg:text-[41px] md:text-[40px] sm:text-[23px] text-[44px]">${valueSplitter(savingGoalValues.at(0).totalSavingsBalance)[0]}</div>
            <div className="lg:text-[36px] md:text-[30px] sm:text-[20px] text-[35px] lg:mt-[-12px] md:mt-[-7px] sm:mt-[-5px] mt-[-11px] md:font-[500] font-[300]">.</div>
            <div className='lg:text-[25px] md:text-[23px] sm:text-[15px] text-[22px] lg:mt-[-6px] md:mt-[-4px] sm:mt-[-3px] mt-[-5px] md:font-[500] font-[300]
                font-hanken-grotesk'>{valueSplitter(savingGoalValues.at(0).totalSavingsBalance)[1]}</div>
            </div>
          </div> */}


        <div className="flex justify-between">

          {/* //1 */}
            <div  className="flex flex-col items-start">
              <div className={`flex md:font-[500] sm:font-[400] font-[500]
          md:leading-[56px] sm:leading-[28.38px] leading-[37.49px]  
          text-[var(--total-savings-color)] font-hanken-grotesk`}>
                <div className="lg:text-[41px] md:text-[40px] sm:text-[23px] text-[44px]">
                  ${valueSplitter(savingGoalValues.at(0).totalSavingsBalance)[0]}
                </div>
                <div className="lg:text-[36px] md:text-[30px] sm:text-[20px] text-[35px] 
            lg:mt-[-12px] md:mt-[-7px] sm:mt-[-5px] mt-[-11px] md:font-[500] font-[300]">
                  .
                </div>
                <div className='lg:text-[25px] md:text-[23px] sm:text-[15px] text-[22px] 
            lg:mt-[-6px] md:mt-[-4px] sm:mt-[-3px] mt-[-5px] md:font-[500] font-[300]
            font-hanken-grotesk'>
                  {/* {valueSplitter(savingGoalValues.at(0).totalSavingsBalance)[1]} */}
                  {valueSplitter(Number(savingGoalValues.at(0).totalSavingsBalance).toFixed(2))[1]}
                </div>
              </div>
              <p className="md:font-[500] md:text-[14px] sm:font-[400] font-[500]
              md:leading-[20px] sm:leading-[28.38px] leading-[20px]
               text-[var(--total-savings-color)] font-hanken-grotesk">{t("total_savings")}</p>
            </div>

            {/* //2 */}
            <div  className="flex flex-col items-start">
              <div className={`flex md:font-[500] sm:font-[400] font-[500]
          md:leading-[56px] sm:leading-[28.38px] leading-[37.49px]  
          text-[var(--savings-goal-total-color)] font-hanken-grotesk`}>
                <div className="lg:text-[41px] md:text-[40px] sm:text-[23px] text-[44px]">
                  ${valueSplitter(savingGoalValues.at(0).savingsBalance)[0]}
                </div>
                <div className="lg:text-[36px] md:text-[30px] sm:text-[20px] text-[35px] 
            lg:mt-[-12px] md:mt-[-7px] sm:mt-[-5px] mt-[-11px] md:font-[500] font-[300]">
                  .
                </div>
                <div className='lg:text-[25px] md:text-[23px] sm:text-[15px] text-[22px] 
            lg:mt-[-6px] md:mt-[-4px] sm:mt-[-3px] mt-[-5px] md:font-[500] font-[300]
            font-hanken-grotesk'>
                  {valueSplitter(savingGoalValues.at(0).savingsBalance)[1]}
                </div>
              </div>
              <p className="md:font-[500] md:text-[14px] sm:font-[400] font-[500]
              md:leading-[20px] sm:leading-[28.38px] leading-[20px]
               text-[var(--savings-goal-total-color)] font-hanken-grotesk">{t("savings_goal_total")}</p>
            </div>

            {/* //3 */}
            <div  className="flex flex-col items-start">
              <div className={`flex md:font-[500] sm:font-[400] font-[500]
          md:leading-[56px] sm:leading-[28.38px] leading-[37.49px]  
          text-[var(--savings-remaining-color)] font-hanken-grotesk`}>
                <div className="lg:text-[41px] md:text-[40px] sm:text-[23px] text-[44px]">
                  ${valueSplitter(savingGoalValues.at(0).savingsRemainingBalance)[0]}
                </div>
                <div className="lg:text-[36px] md:text-[30px] sm:text-[20px] text-[35px] 
            lg:mt-[-12px] md:mt-[-7px] sm:mt-[-5px] mt-[-11px] md:font-[500] font-[300]">
                  .
                </div>
                <div className='lg:text-[25px] md:text-[23px] sm:text-[15px] text-[22px] 
            lg:mt-[-6px] md:mt-[-4px] sm:mt-[-3px] mt-[-5px] md:font-[500] font-[300]
            font-hanken-grotesk'>
                  {valueSplitter(savingGoalValues.at(0).savingsRemainingBalance)[1]}
                </div>
              </div>
              <p className="md:font-[500] md:text-[14px] sm:font-[400] font-[500]
              md:leading-[20px] sm:leading-[28.38px] leading-[20px]
               text-[var(--savings-remaining-color)] font-hanken-grotesk">{t("savings_remaining")}</p>
            </div>
        </div>
        </div>
    </>
  );
};

export const QuickActions = ({ actionsArray, buttonName }) => {
  const navigate = useNavigate();
  const QuickActionsButtons = actionsArray;
  const buttonCount = QuickActionsButtons.length;
  return (
    <>
      <div className='lg:h-[206px] md:h-[190px] sm:h-[155px] h-auto flex justify-center flex-col sm:py-0 sm:mx-0 
      py-8 mx-4'>
        <p className='font-hanken-grotesk text-[var(--primary-text-cards)]  uppercase lg:text-[13px] md:text-[12px] sm:text-[12px] text-[12px] font-[600] tracking-[2px] md:pb-8 pb-4'>
          Quick Actions
        </p>
        <div className='flex flex-wrap justify-between'>
          {QuickActionsButtons.map((object, index) => (
            <button
              // onClick={() => {object.path !== "" ? navigate(object.path) : alert("Coming Soon..")}}

              onClick={() => {
                if (object.path !== "") {
                  navigate(object.path); logFirebaseEvents("Transfer_Money", object.name.replace(/ /g, '_'), object.name.replace(/ /g, '_'), "", "");
                }
                else {
                  alert("Coming Soon..")
                }
              }}
              key={index}
              type="button"
              className={`font-hanken-grotesk mb-5 lg:text-[15px] md:text-[14px] sm:text-[12px] text-[13px]
         md:leading-[39.71px] sm:leading-[25.8px] 
         md:h-[50px] sm:h-[36px] h-[40px] inline-block rounded-full 
         border-[3px] border-[var(--transactions-acc-number-border)] text-[var(--quickActionText)]
         text-xs font-semibold leading-normal text-success 
         transition duration-150 ease-in-out ${buttonCount === 3 ? 'sm:w-[32%] w-full' : (buttonCount >= 4 ? 'sm:w-1/4 w-full' : 'sm:w-[48%]  w-full')}`}
              data-te-ripple-init="true">
              {object.name}
            </button>
          ))}
        </div>
      </div>
    </>
  )
}

//////More Services
export const MoreServices = ({ actionsArray, isMoresetting }) => {
  const navigate = useNavigate();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);

  const appThemeData = appTheme(kudzuPlusTrue)

  const moreService = 'sm:w-[90%] w-full md:pb-[1.5rem] pb-[1.3rem] flex justify-between items-center border-b-[2.5px] border-[var(--transactions-acc-number-border)] cursor-pointer';
  const moreserviceText = 'font-[600] text-[var(--text-clr-transactions)] lg:text-[16px] md:text-[15px] sm:text-[11px] text-[14px] leading-[16px] font-hanken-grotesk';
  return (
    <>
      <div className="md:py-20 sm:py-10 py-8 flex flex-col justify-center">

        {isMoresetting ? (
          <p className='font-hanken-grotesk text-[var(--primary-text-cards)] uppercase lg:text-[13px] md:text-[12px] sm:text-[9px] text-[12px] font-[600] tracking-[2px] md:pb-8 pb-4'>
            {t('more_settings')}
          </p>) :
          < p className='font-hanken-grotesk text-[var(--primary-text-cards)] uppercase lg:text-[13px] md:text-[12px] sm:text-[9px] text-[12px] font-[600] tracking-[2px] md:pb-8 pb-4'>
            {t('more_service')}
          </p>
        }

        <div className='sm:flex w-full md:mb-[3rem] sm:mb-8' >
          {actionsArray.slice(0, 2).map((object, index) => (
            <div key={index} className='sm:w-[50%] w-full sm:mb-0 mb-5'>
              <Link 
                to={object.path}
                onClick={() => { logFirebaseEvents("Manage_Account", object.name, object.name, "", ""); }}
                className="block"
              >
                <div className={moreService}>
                  <p className={moreserviceText}>{object.name}</p>
                  <p><img src={appThemeData.ArrowsIconToSee} className="w-[7px] mr-[10px]" alt="RightArrow" /></p>
                </div>
              </Link>
            </div>
          ))}
        </div>
        <div className='sm:flex  w-full'>
          {actionsArray.slice(2, 4).map((object, index) => (
            <div key={index} className='sm:w-[50%] w-full sm:mb-0 mb-5'>
              <Link 
                to={object.path}
                className="flex justify-between items-center block"
              >
                <div className={moreService}>
                  <p className={moreserviceText}>{object.name}</p>
                  <p><img src={appThemeData.ArrowsIconToSee} className="w-[7px] mr-[10px]" alt="RightArrow" /></p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div >
    </>
  );
};


export function formatDateForTrustDevice(date) {
  if (!date) return "";
  const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true };
  const tempDate = new Date(date);
  const formattedDate = tempDate.toLocaleDateString('en-US', options);
  return formattedDate;
}


export function dashBoardformatDate(inputDate) {
  if (!inputDate) {
    return null; // Return null if the input date is missing or empty
  }
  const parsedDate = new Date(inputDate);
  if (isNaN(parsedDate.getTime())) {
    return null; // Return null if the parsed date is invalid
  }
  const today = new Date();
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const yesterdayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
  const dateStart = new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate());
  if (dateStart.getTime() === todayStart.getTime()) {
    return 'Today';
  }
  if (dateStart.getTime() === yesterdayStart.getTime()) {
    return 'Yesterday';
  }
  const formattedDate = parsedDate.toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
  return formattedDate;
}

export function formatFullDate(inputDate) {
  if (!inputDate) {
    return null; // Return null if the input date is missing or empty
  }
  const parsedDate = new Date(inputDate);
  if (isNaN(parsedDate.getTime())) {
    return null; // Return null if the parsed date is invalid
  }
  const formattedDate = parsedDate.toLocaleDateString(undefined, {
    month: 'long',
    day: 'numeric'
  });
  return formattedDate;
}

/**
 * Formats a transaction date for grouping purposes
 * Returns "Today", "Yesterday", or formatted date string
 * Used for grouping transactions by date in transaction lists
 */
export function formatTransactionGroupDate(value, t) {
  const dateValue = new Date(value);
  if (Number.isNaN(dateValue.getTime())) {
    return dashBoardformatDate(value);
  }
  const today = new Date();
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const yesterdayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
  const dateStart = new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate());

  if (dateStart.getTime() === todayStart.getTime()) {
    return t('today');
  }
  if (dateStart.getTime() === yesterdayStart.getTime()) {
    return t('yesterday');
  }
  return dashBoardformatDate(value);
}

/**
 * Groups transactions by date
 * Separates pending transactions and groups non-pending by date
 * @param {Array} items - Array of transaction items
 * @param {Function} formatDateFn - Function to format dates for grouping
 * @param {String} dateField - Field name containing the transaction date (default: 'TransactionTime')
 * @param {String} statusField - Field name for status checking (default: 'StatusCode')
 * @param {String} pendingValue - Value indicating pending status (default: 'APP')
 * @returns {Object} - Object with pendingItems and groupedByDate
 */
export function groupTransactionsByDate(items, formatDateFn, dateField = 'TransactionTime', statusField = 'StatusCode', pendingValue = 'APP') {
  if (!items || items.length === 0) {
    return { pendingItems: [], groupedByDate: {} };
  }

  const pendingItems = items.filter(item => item[statusField] === pendingValue);
  const nonPendingItems = items.filter(item => item[statusField] !== pendingValue);

  const groupedByDate = nonPendingItems.reduce((groups, item) => {
    const dateKey = formatDateFn(item[dateField]);
    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(item);
    return groups;
  }, {});

  return { pendingItems, groupedByDate };
}

/**
 * Groups upcoming transactions by start date
 * Handles invalid/default dates by grouping them as "Scheduled"
 * @param {Array} items - Array of upcoming transaction items
 * @param {Function} formatDateFn - Function to format dates for grouping
 * @param {Function} t - Translation function
 * @param {String} dateField - Field name containing the start date (default: 'StartDate')
 * @returns {Object} - Object with transactions grouped by date
 */
export function groupUpcomingTransactionsByDate(items, formatDateFn, t, dateField = 'StartDate') {
  if (!items || items.length === 0) {
    return {};
  }

  const checkIfDefaultDate = (value) => {
      return !value ||
      value === "---" ||
      value === t('NotSpecified') ||
      value?.startsWith("9999");
  };

  const groupedByDate = items.reduce((groups, item) => {
    const dateValue = item[dateField];

    if (checkIfDefaultDate(dateValue)) {
      // Group invalid dates under "Scheduled"
      if (!groups[t('scheduled')]) {
        groups[t('scheduled')] = [];
      }
      groups[t('scheduled')].push(item);
    } else {
      const dateKey = formatDateFn(dateValue);
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(item);
    }
    return groups;
  }, {});

  return groupedByDate;
}

export function formatDateYYYYMMDD(date) {
  if (!date) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}



export function formatDateYYYYMMDDFORSCH(date) {

  if (!date) return "";
 
  const formattedDate = new Date(date); // Convert string to Date object
 
  const year = formattedDate.getFullYear();

  const month = String(formattedDate.getMonth() + 1).padStart(2, "0");

  const day = String(formattedDate.getDate()).padStart(2, "0");
 
  return `${year}-${month}-${day}`;

}

 



export function parseGoogleLocationResponse(data) {
  // debugger;
  const addressComponents = data;
  const getComponent = type => {
    const component = addressComponents.find(component => component.types.includes(type));
    return component ? component.long_name : null;

  };
  const getShortNameFromComponent = type => {
    const component = addressComponents.find(component => component.types.includes(type));
    return component ? component.short_name : null;
  };
  const streetNumber = getComponent('street_number') || getComponent('administrative_area_level_4');
  const route = getComponent('route');
  const sublocality = getComponent('sublocality_level_1');
  const naturalFeature = getComponent('natural_feature');
  const locality = getComponent('locality') || getComponent('administrative_area_level_2');
  const administrativeAreaLevel1 = getComponent('administrative_area_level_1');
  const postalCode = getComponent('postal_code');
  const country = getComponent('country');
  const countryCode = getShortNameFromComponent('country');
  var response = {
    streetNumber: streetNumber,
    route: route,
    sublocality: sublocality,
    naturalFeature: naturalFeature,
    locality: locality,
    administrativeAreaLevel1: administrativeAreaLevel1,
    postalCode: postalCode,
    country: country,
    countryCode: countryCode === "US" ? "USA" : countryCode
  }
  return response
}



///////chosse card in accounts services page
export const ChooseCard = ({ imageSource, value, checkingName,
  checkingNameColor, valueColor, LinkTo, Servicecard, index, enrollClicked }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const savingsCardAvailable = useSelector(state => state.savingsAccontAvailable);
  // const savingsNewClicked = useSelector(state => state.savingsNewClicked);
  const cards = useSelector(state => JSON.parse(state.userCards));
  const newbadgeCheck = cards && cards.length > 0   ? `newbadge${cards[0].CardKey}`  : null;
  const savingsNewClicked = Cookies.get(newbadgeCheck) ? true : false;



  // const cardBorderStyle = { borderColor: checkingNameColor }; // Set border color same as checkingNameColor

  return (
    <div className="sm:w-[30%] w-full">
      {checkingName == t('menu_savings') && savingsCardAvailable == false ?
        <Link className="sm:w-[30%] w-full">
          <div className={`relative cursor-pointer 
   lg:rounded-[36px] md:rounded-[25px] rounded-[18px] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] 
   box-border lg:h-[400px] md:h-[270px] h-[210px] border-[2.5px] lg:p-[33px] md:p-[28px] sm:p-4 p-8
   border-[${Servicecard.border}]
  `} onClick={() => {
              dispatch({ type: 'SELECTED_SUB_INDEX', payload: { selectedSubIndex: -1 } });
              if (checkingName === t('menu_external_accounts')) {
                global.isManageExternalAccs = true
                global.selectedAccountServiceCardKey = -1
                navigate(LinkTo)
              } else {
                if (checkingName === t('menu_savings')) {
                  if (savingsCardAvailable == false && savingsNewClicked == false) {
                    const savingsNewPayload = { savingsNewClicked: true };
                    dispatch({ type: 'SAVINSGS_DISABLED', payload: savingsNewPayload });
                    enrollClicked();
                  } else if (savingsCardAvailable == false && savingsNewClicked == true) {
                    //alert("enroll clicked");
                    enrollClicked();
                  } else {
                    global.selectedAccountServiceCardKey = value
                    global.isManageExternalAccs = false
                    navigate(LinkTo)
                  }


                } else {
                  global.selectedAccountServiceCardKey = value
                  global.isManageExternalAccs = false
                  navigate(LinkTo)
                }

              }
            }}>

            <div className="flex justify-between">
              <span className={` font-medium md:text-[14px] sm:text-[11px] 
     font-hanken-grotesk`} style={{ color: `${Servicecard.color}` }}>{(checkingName === 'Checking' || checkingName == 'Spending') ? 'Kudzu Checking' : checkingName === 'Savings' ? 'Kudzu Savings' : checkingName}</span>

              {(checkingName.toLowerCase() != "savings") ? <span className={`md:text-[14px] sm:text-[11px] ${value ? 'before-dots ' : ''} font-[700]
     
   ` } style={{ color: `${Servicecard.color}` }}>{value}</span> :
                (checkingName.toLowerCase() == "savings" && savingsCardAvailable == false && savingsNewClicked == false) ? <div
                  className={`bg-[#2965FB] flex items-center text-white
                   justify-center text-center w-auto px-[15px] md:h-[25px] sm:h-[20px] h-[20px] rounded-[89px]
                   lg:text-[16px] md:text-[12px] sm:text-[12px] text-[12px] font-[400] font-hanken-grotesk cursor-pointer`}
                  onClick={() => {
                    // const savingsNewPayload = { savingsNewClicked: true };
                    // dispatch({ type: 'SAVINSGS_DISABLED', payload: savingsNewPayload });
                     const newbadgeValue = `newbadge${cards[0].CardKey}`;
                          Cookies.set(newbadgeValue, true, { expires: 1825 });
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();

                    }
                  }}
                  tabIndex={0} // Set tabIndex here for the button
                >
                  New
                </div> : (checkingName.toLowerCase() == "savings" && savingsCardAvailable == false && savingsNewClicked == true) ? <div
                  className={`border-2 border-[var(--enroll-btnBorder)] flex items-center  text-[var(--enroll-btnColor)]
                   justify-center text-center w-auto px-[15px] md:h-[25px] sm:h-[20px] h-[20px] rounded-[89px]
                   lg:text-[15px] md:text-[12px] sm:text-[12px] text-[12px] font-semibold font-hanken-grotesk cursor-pointer`}
                  onClick={() => {
                    // alert("enroll clicked");
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();

                    }
                  }}
                  tabIndex={0} // Set tabIndex here for the button
                >
                  Enroll
                </div> : <span className={`md:text-[14px] sm:text-[11px]  ${value ? 'before-dots ' : ''} font-[700]`} style={{ color: `${Servicecard.color}` }}>{value}</span>}
            </div>

            <img className="lg:w-[82px] lg:h-[92.25px] md:w-[55px] md:h-[55px] sm:w-[40px] sm:h-[40px] w-[45px] h-[45px]
   overflow-hidden cursor-pointer absolute lg:bottom-10  md:bottom-7 sm:bottom-5 bottom-8"
            
              src={imageSource}
              alt=""
            />
          </div></Link> :
        <Link to={LinkTo} className="sm:w-[30%] w-full">
          <div className={`relative cursor-pointer 
        lg:rounded-[36px] md:rounded-[25px] rounded-[18px] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] 
        box-border lg:h-[400px] md:h-[270px] h-[210px] border-[2.5px] lg:p-[33px] md:p-[28px] sm:p-4 p-8 
        border-[${Servicecard.border}]
       `} onClick={() => {
              dispatch({ type: 'SELECTED_SUB_INDEX', payload: { selectedSubIndex: -1 } });
              if (checkingName === t('menu_external_accounts')) {
                global.isManageExternalAccs = true
                global.selectedAccountServiceCardKey = -1
                navigate(LinkTo)
              } else {
                global.selectedAccountServiceCardKey = value
                global.isManageExternalAccs = false
                navigate(LinkTo)
              }
            }}>

            <div className="flex justify-between">
              <span className={` font-medium md:text-[14px] sm:text-[11px] 
          font-hanken-grotesk`} style={{ color: `${Servicecard.color}` }}>{(checkingName === 'Checking' || checkingName == 'Spending') ? 'Kudzu Spending' : checkingName === 'Savings' ? 'Kudzu Savings' : checkingName}</span>

              {(checkingName.toLowerCase() != "savings") ? <span className={`md:text-[14px] sm:text-[11px] ${value ? 'before-dots ' : ''} font-[700]
          
        ` } style={{ color: `${Servicecard.color}` }}>{value}</span> :
                (checkingName.toLowerCase() == "savings" && savingsCardAvailable == false && savingsNewClicked == false) ? <div
                  className={`bg-[#2965FB] flex items-center text-white
                        justify-center  text-center w-auto px-[15px] md:h-[25px] sm:h-[20px] h-[20px] rounded-[89px]
                        lg:text-[14px] md:text-[12px] sm:text-[12px] text-[12px] font-semibold font-hanken-grotesk cursor-pointer`}
                  onClick={() => {
                    const savingsNewPayload = { savingsNewClicked: true };
                    dispatch({ type: 'SAVINSGS_DISABLED', payload: savingsNewPayload });
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();

                    }
                  }}
                  tabIndex={0} // Set tabIndex here for the button
                >
                  New
                </div> : (checkingName.toLowerCase() == "savings" && savingsCardAvailable == false && savingsNewClicked == true) ? <div
                  className={`border-2 border-[var(--enroll-btnBorder)] flex items-center  text-[var(--enroll-btnColor)]
                        justify-center text-center w-auto px-[15px] md:h-[25px] sm:h-[20px] h-[20px] rounded-[89px]
                        lg:text-[15px] md:text-[12px] sm:text-[12px] text-[12px] font-semibold font-hanken-grotesk cursor-pointer`}
                  onClick={() => {
                    // alert("enroll clicked");
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();

                    }
                  }}
                  tabIndex={0} // Set tabIndex here for the button
                >
                  Enroll
                </div> : <span className={`md:text-[14px] sm:text-[11px] ${value ? 'before-dots' : ''} font-[700]`} style={{ color: `${Servicecard.color}` }}>{value}</span>}
            </div>

            <img className="lg:w-[82px] lg:h-[92.25px] md:w-[55px] md:h-[55px] sm:w-[40px] sm:h-[40px] w-[45px] h-[45px]
        overflow-hidden cursor-pointer absolute lg:bottom-10  md:bottom-7 sm:bottom-5 bottom-8"
            
              src={imageSource}
              alt=""
            />
          </div>
        </Link>}
    </div>

  );
};


///get all categeories for faqs
export const getCategories = async (freshDeskDomain, freshDeskCategoryID, freshDeskAPIKey) => {
  let faqList = [];
  var url = "https://" + freshDeskDomain + "/api/v2/solutions/categories/" + freshDeskCategoryID + "/folders";
  let headers = await GetApiHeadersWithBearerForSupport(freshDeskAPIKey);
  var response = await getRequestfreshDeskDomian(url, headers);
  var responseObj = JSON.parse(response);
  if (responseObj !== undefined && responseObj.length > 0) {
    faqList = responseObj.filter(obj => obj.name.startsWith('FAQ:'));
    if (faqList.length > 0) {
      return faqList; 
    }else{
      faqList = responseObj.filter(obj => obj.name.endsWith('FAQ'));
      return faqList;
    }
  }
  
}




///get all categeories for faqs
export const getfaqsdata = async (freshDeskDomain, freshDeskCategoryID, freshDeskAPIKey, perPageCount) => {
  var url = "https://" + freshDeskDomain + "/api/v2/solutions/folders/" + freshDeskCategoryID + "/articles?per_page=" + perPageCount;
  let headers = await GetApiHeadersWithBearerForSupport(freshDeskAPIKey)
  var response = await getRequestfreshDeskDomian(url, headers)
  var responseObj = JSON.parse(response);
  var parseresp = parseFaqs(responseObj);
  return parseresp;
}

export const parseFaqs = (parsedResponse) => {

  var faqs = [];
  for (var i = 0; i < parsedResponse.length; i++) {
    var item = parsedResponse[i];
    item.description = item.description.replace(/color:/g, "")
    item.description = item.description.replace(/font-size:/g, "color:#559C7E;")
    item.description = '<meta name="viewport" content="width=device-width, initial-scale=1"><div style="color: #559C7E">' + item.description + '</div>'
    item.description = '<body style="background-color: transparent" zoom: 100%;>' + item.description + '</body>'
    item.description = item.description.replace(/font-family/g, "")
    item.description = item.description.replace(/text-decoration-thickness/g, "")
    item.description = item.description.replace(/text-decoration-style/, "");
    item.description = item.description.replace(/line-height/g, "")
    item.description = item.description.replace(/<a/g, '<a style="color: blue;"');
    item.description = item.description.replace(/<p/g, '<p style="text-align: justify; line-height: 1.5;font-size:16px"');
    item.description = item.description.replace(/<div/g, '<div style="text-align: justify; line-height: 1.5;;font-size:16px"');


    faqs.push(item);

  }

  return faqs

}

///get all categeories for faqs
export const contactUsTypes = async (freshDeskDomain, freshDeskAPIKey) => {
  // debugger;
  var url = "https://" + freshDeskDomain + "/api/v2/ticket_fields?type=default_ticket_type";
  let headers = await GetApiHeadersWithBearerForSupport(freshDeskAPIKey)
  var response = await getRequestfreshDeskDomian(url, headers)
  var responseObj = JSON.parse(response);
  if (responseObj[0].choices.length > 0) {

    var feedbackObj = responseObj[0].choices;
    return feedbackObj;

  } else {
    return [];
  }

}


///get all EsignStatus  
export const EsignStatus = async (cardKey, accessToken) => {
  //debugger;
  if (cardKey == null || cardKey == undefined) {
    return
  }
  const deviceId = await retrieveData('updatedDeviceId')
  const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
  const url = GET_ESIGN_STATUS(cardKey)
  const response = await GetRequest(url, headers);
  const responseJson = JSON.parse(response);
  if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
    return responseJson.Response.OptOut;
  } else {
    return '';
  }
}



///get all EsignStatus  
export const EsignAgreement = async (cardKey, accessToken) => {
  // debugger;
  if (cardKey == null || cardKey == undefined) {
    return
  }

  const deviceId = await retrieveData('updatedDeviceId')
  const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
  const url = GET_ESIGN_AGREEMENT(cardKey)
  const response = await GetRequest(url, headers);
  const responseJson = JSON.parse(response);
  if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
    return responseJson.Response;
  } else {
    return '';
  }
}



///get all EsignStatus  
export const AcceptEsignAgreement = async (cardKey, accessToken, ProgramId) => {
  // debugger;
  let data = [{
    ContentID: ProgramId,
    UserAction: "A"
  }];
  const deviceId = await retrieveData('updatedDeviceId')
  const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
  const url = ACCEPT_E_SIGN_AGGREMENT(cardKey);
  const response = await PostRequest(url, data, headers);
  const responseJson = JSON.parse(response);
  return responseJson;
}


//get User Profile Info

export const getUserProfileInfo = async (cardKey, accessToken) => {
  //  debugger;
  if (cardKey == null || cardKey == undefined) {
    return
  }
  const deviceId = await retrieveData('updatedDeviceId')
  const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
  const url = GET_USER_PORFIE_INFO(cardKey)
  const response = await GetRequest(url, headers);
  const responseJson = JSON.parse(response);
  if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
    return responseJson.Response;
  } else {
    return '';
  }
}


///////////////////////WRITTEN BY KIRAN S


///////SecuritySidebarContent

const SecuritySidebaritem = 'cursor-pointer font-hanken-grotesk font-[600] md:font-[700] lg:leading-[16px] md:leading-[16px] lg:text-[16px] md:text-[14px] sm:text-[14px] text-[15px] text-[#FEFAEE]'
const SecuritySidebaritemSelected = 'cursor-pointer font-hanken-grotesk font-[600] md:font-[700] lg:leading-[16px] md:leading-[16px] lg:text-[16px] md:text-[14px] sm:text-[14px] text-[15px] text-[#94C3E8]'

export const clearStorageExceptKey = (storage, keyToPreserve) => {
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    if (key !== keyToPreserve) {
      storage.removeItem(key);
    }
  }
};

export const SecuritySidebar = ({ changePasswordClicked, selectedIndex }) => {

  const handleChangePasswordClicked = () => {

    changePasswordClicked()
  };




  return (
    <>
      <div className='lg:w-[260px] md:w-[290px] w-[185px] sm:mx-0 ml-[2.5rem]'>
        <p className="text-white font-normal
        lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] 
        sm:leading-[30px] leading-[31px]
         font-serif-pro border-b-[2.5px]
         border-[#4B70B9] lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10
           border-opacity-[50%]">{t("account_secure")}</p>

        <div className="flex flex-col sm:pb-0 pb-10">

          <p onClick={handleChangePasswordClicked} className={`${selectedIndex === 1 ? SecuritySidebaritemSelected : SecuritySidebaritem} p-8 pl-0 font-hanken-grotesk md:text-[16px] font-[600] text-[11px] sm:font-[700]`}>
            {t("change_password")}</p>

          <Link to="/Security/TrustedDevice" onClick={() => logFirebaseEvents("Trust_Device", "Trust_Devices_Clicked", "Trust_Devices_Clicked", "", "")}>
            <p className={`${selectedIndex === 2 ? SecuritySidebaritemSelected : SecuritySidebaritem} p-8 pl-0 font-hanken-grotesk md:text-[16px] font-[600] text-[11px] sm:font-[700]`}>
              {t("trusted_devices")}
            </p>
          </Link>
        </div>
      </div>
      <div className='md:w-[150px] sm:w-[70px] w-[0px]'></div>
    </>
  )
}

///////Help Sidebar Content  
const helpListItems = 'cursor-pointer font-hanken-grotesk font-[600] lg:text-[16px] md:text-[14px] sm:text-[14px] text-[15px] leading-[20px] md:font-[700] md:leading-[16px] lg:leading-[16px] text-[#FEFAEE]'
const helpListItemsSelected = 'cursor-pointer font-hanken-grotesk font-[600] lg:text-[16px] md:text-[14px] sm:text-[14px] text-[15px] leading-[20px] md:font-[700] md:leading-[16px] lg:leading-[16px] text-[#94C3E8]'

export const HelpSidebar = ({ HelpselectedIndex }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isKudzuOpen, setIsKudzuOpen] = useState(false);
  const smiOneTrue = useSelector((state) => state?.smiOneAccountTrue);
  const hasKudzuCard = useSelector((state) => state.hasKudzuCard);
  return (
    <div className='hidden sm:block lg:w-[262px] md:w-[275px] sm:w-[173px] w-[192px] sm:mx-0 ml-[2.5rem]'>
      <p className="text-white font-normal
            lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] sm:leading-[30px]
             leading-[31px] font-serif-pro border-b-[2.5px]
   border-[#4B70B9] lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10  border-opacity-[50%]">{t("helpHeading")}</p>

      {smiOneTrue ? (
  <div className='relative'>


    <button onClick={() => navigate("/Help/smiONE")} className='text-white font-semibold'>
      {('smiONE')}
    </button>
          {hasKudzuCard &&
            <div className='relative mt-4'>
              <p onClick={() => navigate("/Help/Kudzu")} className='cursor-pointer text-white font-semibold'>
                {t('Kudzu')}
              </p>
            </div>
          }
    
  </div>
) : (
  <div className='flex flex-col md:gap-10 gap-8 sm:pb-0 pb-10'>
    <p
      className={HelpselectedIndex === 2 ? helpListItemsSelected : helpListItems}
      onClick={() => {
        navigate("/Help/FAQ");
        logFirebaseEvents("Help", "Help_And_Faq_Clicked", "Help_And_Faq_Clicked", "", "");
      }}
    >
      {t("helpfaq")}
    </p>


    <p
      className={HelpselectedIndex === 3 ? helpListItemsSelected : helpListItems}
      onClick={() => {
        navigate("/Help/FindATM");
        logFirebaseEvents("Help", "Find_ATM_Clicked", "Find_ATM_Clicked", "", "");
      }}
    >
      {t("findATMBtn")}
    </p>


    <p
      className={HelpselectedIndex === 4 ? helpListItemsSelected : helpListItems}
      onClick={() => {
        navigate("/Help/ContactUs");
        logFirebaseEvents("Help", "Contact_Us_Clicked", "Contact_Us_Clicked", "", "");
      }}
    >
      {t("conatctus")}
    </p>
  </div>
)}

</div>
  )};

  export const SMIHelpSidebar = ({ HelpselectedIndex, isSubMenu }) => {
    const navigate = useNavigate();
    const hasKudzuCard = useSelector((state) => state.hasKudzuCard);
    return (
      <div className='hidden sm:block lg:w-[262px] md:w-[275px] sm:w-[173px] w-[192px] sm:mx-0 ml-[2.5rem]'>
        <p className="text-white font-normal
              lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] sm:leading-[30px]
               leading-[31px] font-serif-pro border-b-[2.5px]
     border-[#4B70B9] lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10  border-opacity-[50%]">{t("helpHeading")}</p>
  
    <div className='relative'>
  
  
      <button onClick={() => navigate("/Help/smiONE")} className={`${HelpselectedIndex === 0 ? "text-[#94C3E8]" : "text-white"} cursor-pointer font-semibold`}>
        {('smiONE')}
      </button>
  
        {isSubMenu && (
        <div className='flex flex-col gap-8 mt-4 text-white p-4 rounded-md'>
          <p
            className={HelpselectedIndex === 1 ? helpListItemsSelected : helpListItems}
            onClick={() => {
              navigate("/Help/smiONE/FAQ");
              logFirebaseEvents("Help", "Help_And_Faq_Clicked", "Help_And_Faq_Clicked", "", "");
            }}
          >
            {t("SMI_FAQ_TEXT")}
          </p>
  
  
          <p
            className={HelpselectedIndex === 2 ? helpListItemsSelected : helpListItems}
            onClick={() => {
              navigate("/Help/smiONE/FindATM");
              logFirebaseEvents("Help", "Find_ATM_Clicked", "Find_ATM_Clicked", "", "");
            }}
          >
            {t("findATMBtn")}
          </p>
  
  
          <p
            className={HelpselectedIndex === 3 ? helpListItemsSelected : helpListItems}
            onClick={() => {
              navigate("/Help/smiONE/ContactUs");
              logFirebaseEvents("Help", "Contact_Us_Clicked", "Contact_Us_Clicked", "", "");
            }}
          >
            {t("conatctus")}
          </p>
        </div>
        )}
          {hasKudzuCard &&
            <div className='relative mt-4'>
              <p onClick={() => navigate("/Help/Kudzu")} className='cursor-pointer text-white font-semibold'>
                {t('Kudzu')}
              </p>
            </div>
          }
      
    </div>
 
  </div>
    )};

    export const KudzuHelpSidebar = ({ HelpselectedIndex, isSubMenu }) => {
      const navigate = useNavigate();
    
      return (
        <div className='hidden sm:block lg:w-[262px] md:w-[275px] sm:w-[173px] w-[192px] sm:mx-0 ml-[2.5rem]'>
          <p className="text-white font-normal
                lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] sm:leading-[30px]
                 leading-[31px] font-serif-pro border-b-[2.5px]
       border-[#4B70B9] lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10  border-opacity-[50%]">{t("helpHeading")}</p>
    
         
      <div className='relative'>
    
    
        <button onClick={() => navigate("/Help/smiONE")} className='text-white font-semibold'>
          {('smiONE')}
        </button>
    
        <div className='relative mt-4'>
          <p onClick={() => navigate("/Help/Kudzu")} className={`${HelpselectedIndex === 0 ? "text-[#94C3E8]" : "text-white"} cursor-pointer font-semibold`}>
            {t('Kudzu')}
          </p>
          {isSubMenu && (
            <div className='flex flex-col gap-8 mt-2 text-white p-4'>
              <p
              className={HelpselectedIndex === 1 ? helpListItemsSelected : helpListItems}
              onClick={() => {
                navigate("/Help/Kudzu/FAQ");
                logFirebaseEvents("Help", "Help_And_Faq_Clicked", "Help_And_Faq_Clicked", "", "");
              }}
            >
              {t("Kudzu_FAQ")}
            </p>
            <p
              className={HelpselectedIndex === 2 ? helpListItemsSelected : helpListItems}
              onClick={() => {
                navigate("/Help/Kudzu/FindATM");
                logFirebaseEvents("Help", "Find_ATM_Clicked", "Find_ATM_Clicked", "", "");
              }}
            >
              {t("findATMBtn")}
            </p>
    
    
            <p
              className={HelpselectedIndex === 3 ? helpListItemsSelected : helpListItems}
              onClick={() => {
                navigate("/Help/Kudzu/ContactUs");
                logFirebaseEvents("Help", "Contact_Us_Clicked", "Contact_Us_Clicked", "", "");
              }}
            >
              {t("Kudzu_Contact")}
            </p>
            </div>
          )}
        </div>
      </div>
    
    </div>
      )};

export function formatDate(timestamp) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const date = new Date(timestamp);
  const formattedDate = date.toLocaleDateString('en-US', options);

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const period = hours >= 12 ? 'PM' : 'AM';
  const formattedTime = `${(hours % 12) || 12}:${minutes.toString().padStart(2, '0')} ${period}`;

  return `${formattedDate} at ${formattedTime}`;
}

export const formatDateAndTime = (isoString) => {
  const date = new Date(isoString);

  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Ensures two-digit month
  const day = date.getDate().toString().padStart(2, "0"); // Ensures two-digit day
  const year = date.getFullYear();

  const formattedDate = `${month}-${day}-${year}`; // Extracts YYYY-MM-DD
  return formattedDate;
};


//modifcation of frequency values
export function getFrequencyAbbreviation(frequencyType) {
  //alert(frequencyType);
  switch (frequencyType) {
    case "Weekly":
      return "WY";
    case "Daily":
      return "DY";
    case "Monthly":
      return "MY";
    default:
      return frequencyType;
  }
}

///climb object creations
///climb object creation for setting screen
export const generateClimbData = (item, savingsAccount, handleTermsClick) => { 
  const kudzuPlusTrue = store.getState().kudzuPlusTrue;
  const appThemeData = appTheme(kudzuPlusTrue);

  let image = '';
  let desc = '';
  let optinStatus = '';
  let buttonText = '';
  let link = '';
  let headingText = item.displayText;
  let note = '';
  let type = '';
  let optinVal = '';

  if (item.code === SPENDING_ALERT) {
    desc = t('spendingAlertMessage');
    note = <p><sup className="md:text-[10px] sm:text-[6px] text-[10px] font-semibold">1<sup className="md:text-[10px] sm:text-[6px] text-[10px] font-semibold"></sup></sup>{t("climb_menu_note")}</p>
    image = appThemeData.climbAddalerts
    buttonText = (item.hasConfigurations) ? t('manageAlerts') : t('addAlerts');
    optinStatus = (item.code === SPENDING_ALERT ? false : false)
    if (item.hasConfigurations) {
      debugger;
      link = '/Toolkit/ManageSpendAlerts'
    } else {
      link = '/Toolkit/AddSpendAlerts'
    }
  }
  else if (item.code === COVERED_BY_KUDZU) {
    image = appThemeData.climbCoveredByKudzuwithOutcheck;
    optinStatus = item.optedIn ? true : false;
    
    if (item.optedIn) {
      buttonText = t('active')
      link = '/Toolkit/ManageCoveredByKudzu';
    } else {
      buttonText = t('activate')
      link = '/Toolkit/CoveredByKudzu'
      note = <p><sup className="md:text-[10px] sm:text-[6px] text-[10px] font-semibold">2<sup className="md:text-[10px] sm:text-[6px] text-[10px] font-semibold"></sup></sup>{addLineBreaks(t("CBK_ADD_disclaimer2"))}<span className="underline cursor-pointer" onClick={handleTermsClick}>View full terms.</span></p>
    }
    // desc = t('converdByKudzuDesc');
    desc = <p>{t('converdByKudzuDescSuperScriptPart1')}Kudzu<sup className="md:text-[10px] sm:text-[6px] text-[10px] font-semibold">2<sup className="md:text-[10px] sm:text-[6px] text-[10px] font-semibold"></sup></sup>{t('converdByKudzuDescSuperScriptPart2')}</p>;

  } 
  else if (item.code === COVERED_BY_KUDZU_PLUS) {
        image = appThemeData.climbCoveredByKudzuwithOutcheck;
        optinStatus = item.optedIn ? true : false;
        // link = '/Toolkit/CoveredByKudzuPlus' 
        if (item.optedIn) {
          buttonText = t('activate')
          link = '/Toolkit/CoveredByKudzuPlus'
    } else {
      buttonText = t('activate')
    }
     desc = <p>{t('coverdByKudzu')}</p>;
     type = item.code

      }
  else if (item.code === SAVINGS_GOALS) {
        image = appThemeData.climbSavingsGoalImg;
        optinVal = item.optedIn ? true : false;
        // if (item.optedIn) {
        //   buttonText = t('activate')
    
        // } else {
        //   buttonText = t('activate')
        // }
        buttonText = item.hasConfigurations ? t('Manage_Goals') : t('addGoals');
        desc = <p>{t('Identify_your_unique_Savings_Goals')}</p>;
        type = item.code
      }
  else if (item.code === SAVINGS_HABIT) {
    desc = t('savigHbitDesc');
    image = appThemeData.climbSavingsHabitImg
    buttonText = (item.hasConfigurations) ? t('manageHabits') : t('addHabits');
    optinStatus = (item.code === SAVINGS_HABIT ? false : false)
    if (item.hasConfigurations) {

      link = '/Toolkit/ManageSavingsHabit'
    } else {
      link = '/Toolkit/AddSavingsHabit'
    }
  }

  return {
    image: image,
    code: item.code,
    heading: headingText,
    subheading: desc,
    buttonText: buttonText,
    Disabled: optinStatus,
    link: link,
    note: note,
    type:type,
    optinVal:optinVal
  };
}; 



// export const generateClimbDataPlus = (item) => {
//   let image = '';
//   let desc = '';
//   let optinStatus = '';
//   let buttonText = '';
//   let link = '';
//   let headingText = item.displayText;
//   let note = '';
//   if (item.code === COVERED_BY_KUDZU) {
//     image = coverdImg
//     optinStatus = item.optedIn ? true : false;
//     // link = '/Toolkit/CoveredByKudzu'
//     if (item.optedIn) {
//       buttonText = t('activate')

//     } else {
//       buttonText = t('activate')
//     }
//     desc = <p>{t('coverdByKudzu')}</p>;
//   }
//   if (item.code === COVERED_BY_KUDZU_PLUS) {
//     image = coverdImg
//     optinStatus = item.optedIn ? true : false;
//     // link = '/Toolkit/CoveredByKudzu'
//     if (item.optedIn) {
//       buttonText = t('activate')

//     } else {
//       buttonText = t('activate')
//     }
//     desc = <p>{t('coverdByKudzu')}</p>;
//   }
//    else if (item.code === SAVINGS_HABIT) {
//     desc = t('savigHbitDesc');
//     image = SavingsHabit;
//     buttonText = (item.hasConfigurations) ? t('addGoals') : t('addGoals');
//     optinStatus = (item.code === SAVINGS_HABIT ? false : false)
//     if (item.hasConfigurations) {

//       //link = '/Toolkit/ManageSavingsHabit'
//     } else {
//       // link = '/Toolkit/AddSavingsHabit'
//     }
//   }
//   return {
//     image: image,
//     code: item.code,
//     heading: headingText,
//     subheading: desc,
//     buttonText: buttonText,
//     Disabled: optinStatus,
//     link: link,
//     note: note,
//   };
// };





export const generateClimbSettingsData = (item) => {
  // debugger;
  let title = '';
  let content = '';
  let optinStatus = '';

  if (item.code === SPENDING_ALERT) {
    title = item.displayText
    content = t('spedningAlertPauseMsg');
    optinStatus = item.optedIn;
  } else if (item.code === COVERED_BY_KUDZU) {
    title = item.displayText
    content = t('coverdBykudzuDesc');
    optinStatus = item.optedIn;
  } else if (item.code === SAVINGS_HABIT) {
    title = item.displayText
    optinStatus = item.optedIn;
    content = t('savingHabiPauseMsg');
  }
   else if (item.code === SAVINGS_GOALS) {
    title = item.displayText
    optinStatus = item.optedIn;
    content = t('savings_goals_pauseMsg');
  }

  return {
    code: item.code,
    title: title,
    optinStatus: optinStatus,
    content: content
  };

};



export const modifyHtmlForNavigation = (htmlString, color, isUnread = true) => {
  if (typeof htmlString !== 'string') {
    return htmlString;
  }

  // Add inline style with the provided color to anchor tags
  const modifiedHtml = htmlString.replace(/<a\s+([^>]*)>/g, (href) => {
    // console.log("href---", href.slice(0, href.length - 1))
    return `${href.slice(0, href.length - 1)} style="color: ${color}">`;
  });
  // const modifiedHtml = htmlString.replace(/<a\s+(?:[^>]*?\s+)?href="([^"]*)"[^>]*>/gi, (match, href) => {
  //   return `<a href="${href}" style="color: ${color};">`;
  // });

  // console.log("modifiedHtml", modifiedHtml)

  return modifiedHtml;
};

export const delayForDemo = (promise) => {
  return new Promise(resolve => {
    setTimeout(resolve, 1000);
  }).then(() => promise);
}


////notification navigations
export const useNotificationNavigation = () => {
  const navigate = useNavigate();
  const cards = useSelector(state => JSON.parse(state.userCards));
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const userMembershipData = getUserMembership(loggedResponse)

  const notificationNavigation = (href, e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("navigatehref---", href)

    switch (href) {
      case "cbk-plus-learn-more":
        navigate('/Settings/manageMembershipKudzuplus')
        break;
      case "cbk-plus-opt-in":
        navigate('/home')
        break;
      case "covered-by-kudzu-plus-opt-in":
        navigate('/Toolkit/ToolkitSettings');
        break;
      case "manage-savings-goal":
        navigate("/Toolkit/SavingGoals/ManageSavingGoal");
        break;
      case "savings-goal-transactions":
        navigate("/Savings");
        break;
      // case "transactions":
      //   navigate("/Spending");
      //   break;
      case NOTIF_CUSTOMER_CARE:
        navigate("/Help/ContactUs");
        break;
      case NOTIF_CARD_SERVICES:
        navigate("/CardServices");
        break;
      case NOTIF_TRANSACTIONS:
        navigate("/Spending");
        break;
      case NOTIF_STATEMENTS:
        navigate("/Documents/Statements");
        break;
      case NOTIF_FEES:
        navigate("/Documents/Fees");
        break;
      case NOTIF_MANAGE_SAVINGS_HABIT:
        navigate("/Toolkit/ManageSavingsHabit");
        break;
      case NOTIF_SPENDSENSE_ALERT:
        navigate("/Toolkit/ManageSpendAlerts");
        break;
      case NOTIF_SPENDSENSE_ALERT2:
        navigate("/Toolkit/ManageSpendAlerts");
        break;
      case NOTIF_PAYPERKS:
        navigate("/PayPerks");
        break;
      case NOTIF_PERSONAL_INFO:
        navigate("/PersonalInformation");
        break;
      case NOTIF_COVERED_BY_KUDZU_OPT_IN:
        navigate('/Toolkit/ToolkitSettings');
        break;
      case NOTIF_COVERED_BY_KUDZU_TERMS:
        navigate(
         "/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions",
          {
            state: {
              name: "Covered by Kudzu Terms and Conditions",
              url:
              userMembershipData?.membershipType === "Plus" ||
              userMembershipData?.membershipType === "Trial"
              ? "CoveredByKudzuPlusTerms"
              : "CoveredByKudzuTerms",
              accType: 64,
              CardKey: cards?.[0]?.CardKey,
            },
          }
        ); 
        break;
      case cbk_transaction:
        navigate("/notifications-details");
        break;
      case NOTIF_MANAGE_DIRECT_DEPOSIT:
        navigate("/AccountServices/Spending/AddFunds/ManageDirectDeposit");
        break;
      case Add_Money_PopOver:
        navigate("/AccountServices/Spending/TransferMoney");
        break;
      case Kudzu_Plus_Opt_In:
        navigate("/Settings/manageMembershipKudzuplus");
        break;
      case href.match(/^savings-goal\/\d+\/details$/)?.input: {
        const match = href.match(/^savings-goal\/(\d+)\/details$/);
        const goalKey = match ? match[1] : '';
        navigate(`/Toolkit/SavingGoals/ManageSavingGoal?goalKey=${goalKey}`);
        break;
      } 
      case MOBILE_UPDATE_IDOLOGY_VERIFY:
        navigate(`/PersonalInformation?verify=${true}`);
        break;
       case NOTIF_ACCOUNT_SERVICE:
        navigate(`/AccountServices`);
        break;
      default:
        break;
    }
  };

  return notificationNavigation;
};

export const APP_ENV = 'APP_ENV';
export const BIOMETRIC = "biometric";
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const USERNAME = "USERNAME";
export const REFRESH_TOKEN = "REFRESH_TOKEN"
export const IS_TRUSTED_DEVICE = "IsTrustedDevice";
export const USER_PROFILE = "userProfile";
export const USER_CARDS = "userCards";
export const USER_ACTIVITIES = "userActivities";
export const USER_LANGUAGE = "userLanguage";
export const SPENDING = "Spending"
export const SAVINGS = "Savings"
export const SHARED = "Shared"
export const FaceID = "Face ID"
export const TouchID = "Touch ID"
export const Biometric = "Biometric"
export const FingerPrint = "Fingerprint Recognition"
export const APP_BG_TIME = "APP_BG_TIME";
export const APP_BG_TIME_IN_SECS = 1800;
export const CHECKING = "Checking";
export const AMOUNT_MAX_FILTERS = 500;
export const AMOUNT_MIN_FILTERS = 0;
export const TIME_MAX_FILTERS = 6;
export const TIME_MIN_FILTERS = 0;
export const SLIDER_MIN_POSITION = -10;
export const SLIDER_MAX_POSITION = 230;
export const SPENT_AMOUNT_DEFAULT_DAYS = 7;
export const MIN_PASSWORD_LENGTH = 1
export const PENDING = "Pending"
export const DEVICE_VERIFICATION = "DeviceVerification";
export const LOGIN = "Login";
export const MAX_RETRY_COUNT = 3;
export const TNC = "TnC";
export const PRIVACY_POLICY = "PrivacyPolicy";
export const ESIGN = "ESign";
export const SmioneCard ="smiONE Card"



